export default {
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    noData: 'No data',
    useAssistant: 'Use the AI assistant to get started',
    confirm: 'Confirm',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    name: 'Name',
    description: 'Description',
    type: 'Type',
    download: 'Download',
    upload: 'Upload',
    copy: 'Copy',
    copied: 'Copied!',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    all: 'All',
    allTypes: 'All types',
    allStatuses: 'All statuses',
    none: 'None',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    refresh: 'Refresh',
    back: 'Back',
    goBack: 'Go Back to Dashboard',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    submit: 'Submit',
    confirmDeleteItem: 'Are you sure you want to delete this item?',
    validateForReport: 'Validate for Report',
    reset: 'Reset',
    view: 'View',
    details: 'Details',
    more: 'More',
    less: 'Less',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This week',
    thisMonth: 'This month',
    optional: 'optional',
    unknown: 'Unknown',
    notDetected: 'Not Detected',
    notDetectedFeminine: 'Not Detected',
    notAvailable: 'Not available',
    required: 'Required',
    note: 'Note:',
    and: 'and',
    or: 'or',
    sending: 'Sending...',
    copyright: '© 2026 SYLink. All rights reserved.',
    add: 'Add',
    execute: 'Execute',
    launch: 'Launch',
    pause: 'Pause',
    generating: 'Generating...',
    copiedToClipboard: 'Copied to clipboard',
    emailRequired: 'Email required',
    regenerate: 'Regenerate',
    deselect: 'Deselect',
    requiredFields: 'Required fields',
    andThe: 'and the',
    redirecting: 'Redirecting...',
    severities: {
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low/Info',
    },
    recommendations: 'Recommendations',
    severity: 'Severity',
    service: 'Service',
    resource: 'Resource',
    region: 'Region',
    retry: 'Retry',
    vulnerabilities: 'Vulnerabilities',
    pagination: {
      first: 'First page',
      previous: 'Previous page',
      next: 'Next page',
      last: 'Last page',
    },
    creating: 'Creating...',
  },

  // APT Modules
  apt: {
    dangerousModule: 'Dangerous module - Use with caution',
    addToChain: 'Add to a chain',
    createChain: 'Create an attack chain',
    createChainButton: 'Create chain',
    chainName: 'Chain name',
    selectedModules: 'Selected modules',
    addModulesFromList: 'Add modules from the list on the right',
    availableModules: 'Available modules',
    newChain: 'New chain',
    executeModule: 'Execute {name}',
    loadError: 'Error loading APT data',
    requiredParams: 'Required parameters',
    executions: 'Executions',
    successful: 'successful',
    avgTime: 'Avg. time',
    modulesApt: 'APT Modules',
    chains: 'Chains',
    evidence: 'Evidence',
    mitreMatrix: 'MITRE ATT&amp;CK Matrix',
    category: 'Category',
    criticality: 'Criticality',
    mitreTactic: 'MITRE Tactic',
    allCategories: 'All',
    allCriticalities: 'All',
    allTactics: 'All',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical',
    noModulesAvailable: 'No APT campaigns available at the moment',
    noModulesFiltered: 'No modules match the selected filters',
    noChains: 'No attack chains created. Create one to get started.',
    noEvidence: 'No evidence collected. Execute modules to collect evidence.',
    chainStatus: 'Status',
    chainProgress: 'Progress',
    chainModules: 'Modules',
    chainCreatedAt: 'Created',
    executeChain: 'Execute {name}',
    moduleLaunched: 'Module {name} launched',
    moduleLaunchError: 'Error launching module',
    chainCreated: 'Chain created successfully',
    chainCreateError: 'Error creating chain',
    chainLaunched: 'Chain launched',
    chainLaunchError: 'Error launching chain',
    chainPaused: 'Chain paused',
    chainCancelled: 'Chain cancelled',
    dangerWarning: 'This module is marked as dangerous. Use with caution.',
    modulesAvailable: 'modules available',
    target: 'Target',
    duration: 'Duration',
    result: 'Result',
    title: 'Title',
    classification: 'Classification',
    size: 'Size',
    validated: 'Validated',
    searchPlaceholder: 'Search...',
    tool: 'Tool',
    module: 'Module',
    exitCode: 'Exit code',
    status: {
      pending: 'Pending',
      queued: 'Queued',
      running: 'Running',
      paused: 'Paused',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled',
      draft: 'Draft',
      ready: 'Ready'
    },
    categories: {
      reconnaissance: 'Reconnaissance',
      resource_development: 'Resource Development',
      initial_access: 'Initial Access',
      execution: 'Execution',
      persistence: 'Persistence',
      privilege_escalation: 'Privilege Escalation',
      defense_evasion: 'Defense Evasion',
      credential_access: 'Credential Access',
      discovery: 'Discovery',
      lateral_movement: 'Lateral Movement',
      collection: 'Collection',
      command_and_control: 'Command and Control',
      exfiltration: 'Exfiltration',
      impact: 'Impact'
    },
    criticalities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical'
    }
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    scans: 'Scans',
    workspaces: 'Workspaces',
    vulnerabilities: 'Vulnerabilities',
    reports: 'Reports',
    settings: 'Settings',
    account: 'My Account',
    logout: 'Logout',
    help: 'Help',
    admin: 'Administration',
    tools: 'Tools',
    compliance: 'Compliance',
    notifications: 'Notifications',
    credentials: 'Credentials',
    ad: 'Active Directory',
    sessions: 'Sessions',
    agents: 'Agents'
  },

  // Auth
  auth: {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    forgotPassword: 'Forgot password?',
    magicLink: 'Magic Link',
    resetPassword: 'Reset password',
    resetPasswordNeedsLink: 'To reset your password, use the link sent by email. You can request a new link from the login page.',
    rememberMe: 'Remember me',
    loginSuccess: 'Login successful',
    loginError: 'Invalid credentials',
    logoutSuccess: 'Logout successful',
    sessionExpired: 'Session expired',
    twoFactor: 'Two-factor authentication',
    enterCode: 'Enter the code',
    verifyCode: 'Verify code',
    invalidCode: 'Invalid code',
    // Register page
    createAccount: 'Create an account',
    fillFormBelowEmail: 'Fill in the form below to create your business account.',
    companyName: 'Company name',
    companyPlaceholder: 'Your company',
    firstName: 'First name',
    firstNamePlaceholder: 'Your first name',
    lastName: 'Last name',
    lastNamePlaceholder: 'Your last name',
    professionalEmail: 'Professional email',
    professionalEmailPlaceholder: 'you@yourcompany.com',
    professionalPhone: 'Professional phone',
    phonePlaceholder: '+1 234 567 8900',
    phoneFormatHint: 'The country prefix is pre-filled automatically. Format: +1 234 567 8900',
    passwordEmailNote: 'You will set your password after validating your email.',
    acceptTermsPrefix: 'I accept the',
    createMyAccount: 'Create my account',
    registering: 'Creating...',
    alreadyHaveAccount: 'Already have an account?',
    loginButton: 'Log in',
    byRegistering: 'By creating an account, you agree to our terms of use and privacy policy.',
    registrationSuccess: 'Registration successful!',
    demoAccountReady: 'Your demo account is ready!',
    createDemoAccount: 'Create your demo account',
    fillDemoInfo: 'Enter your information to access your demo space.',
    passwordMinLength: 'Minimum 8 characters',
    passwordMinLengthError: 'Password must be at least 8 characters',
    registrationEmailSent: 'A confirmation email has been sent to',
    clickLinkToSetPassword: 'Click the link to set your password and activate your account.',
    checkSpam: 'Check your spam folder if you don\'t see the email.',
    backToLogin: 'Back to login',
    // Login page
    welcomeBack: 'Welcome back!',
    enterCredentials: 'Enter your credentials to access your space.',
    loggingIn: 'Logging in...',
    noAccount: 'Don\'t have an account?',
    createAccountLink: 'Create an account',
    // Email verification
    verifying: 'Verifying...',
    verifyingDescription: 'Please wait while we verify your email address.',
    emailVerified: 'Email verified!',
    accountActive: 'Your account is now active.',
    welcome: 'Welcome to SYLink!',
    choosePlan: 'Choose my plan',
    redirectingToPlan: 'Redirecting to pricing in {seconds} seconds...',
    orLoginDirectly: 'Or {loginLink} directly',
    verificationFailed: 'Verification failed',
    needNewVerificationLink: 'Need a new verification link?',
    yourEmail: 'Your email',
    emailSent: 'Email sent!',
    resendLink: 'Resend link',
    invalidLink: 'Invalid link',
    requestNewVerificationLink: 'Request a new verification link',
    sendLink: 'Send link',
    // Password reset / Forgot password modal
    resetPasswordTitle: 'Reset password',
    resetPasswordDesc: 'Enter your email to receive a reset link.',
    sendResetLink: 'Send reset link',
    forgotPasswordModalTitle: 'Forgot password?',
    emailSentTitle: 'Email sent',
    checkYourInbox: 'Check your inbox',
    ifAccountExistsPrefix: 'If an account exists with the address',
    ifAccountExistsSuffix: ', you will receive a link to reset your password.',
    linkExpiresCheckSpam: 'The link will expire in 24 hours. Please check your spam folder.',
    enterEmailForResetLink: 'Enter your email address and we will send you a link to reset your password.',
    emailAddressLabel: 'Email address',
    sendResetLinkFull: 'Send reset link',
    sendingInProgress: 'Sending...',
    connectionError: 'Connection error. Please try again.',
    sending: 'Sending...',
    resetLinkSent: 'Link sent!',
    resetLinkSentDesc: 'Check your mailbox to reset your password.',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm password',
    setNewPassword: 'Set password',
    passwordUpdated: 'Password updated!',
    passwordUpdatedDesc: 'You can now log in with your new password.',
    // Reset password page
    passwordGenerator: 'Password Generator',
    regenerate: 'Regenerate',
    classic: 'Classic',
    quantumResistant: 'Quantum-Resistant',
    quantumSecurityDescription: 'Maximum security against future quantum attacks',
    passwordChanged: 'Password changed!',
    passwordResetSuccess: 'Your password has been successfully reset. You will be redirected to the login page.',
    chooseSecurePassword: 'Choose a secure password for your account',
    orEnterManually: 'or enter manually',
    newPasswordPlaceholder: 'Enter your new password',
    confirmPasswordPlaceholder: 'Confirm your password',
    minChars: '8 characters min',
    uppercase: '1 uppercase',
    lowercase: '1 lowercase',
    number: '1 number',
    specialChar: '1 special character',
    passwordsMatch: 'Passwords match',
    resettingPassword: 'Resetting...',
    charactersCount: '{count} characters',
    // Login page additional
    loginSubtitle: 'Log in to access your security space.',
    emailNotVerified: 'Email not verified',
    emailNotVerifiedMessage: 'Please check your mailbox and click the confirmation link.',
    verificationEmailSent: 'Verification email sent!',
    resendVerificationLink: 'Resend verification email',
    accountBlocked: 'Account blocked',
    personalEmailBlockedMessage: 'This account uses a personal email address that is no longer accepted.',
    securityPolicy: 'Security policy:',
    professionalEmailOnly: 'Only professional email addresses are allowed.',
    personalEmailsNotAccepted: 'Personal emails (Gmail, Hotmail, Yahoo, etc.) are not accepted.',
    createNewAccountMessage: 'To continue, create a new account with your professional email:',
    createAccountWithProfessionalEmail: 'Create an account with professional email',
    needHelp: 'Need help? Contact us',
    emailOrUsername: 'Email',
    emailPlaceholder: 'you@company.com',
    passwordPlaceholder: 'Password',
    createFreeAccount: 'Create a free account',
    // Magic link page
    magicLinkLoginFailed: 'Login failed. Please try again.',
    magicLinkInvalid: 'This link is no longer valid.',
    magicLinkNotFound: 'This link does not exist or has already been used.',
    magicLinkExpired: 'This link has expired. Please request a new one.',
    unauthorized: 'Unauthorized access',
    connectionError: 'Connection error. Check your internet connection and try again.',
    genericError: 'An error occurred. Please try again.',
    verificationTimeout: 'Verification took too long. Please try again.',
    retrying: 'Retrying...',
    verifyingLink: 'We are verifying your login link',
    loginSuccess: 'Login successful!',
    redirectingToDashboard: 'You will be redirected to your dashboard...',
    autoRedirecting: 'Automatic redirection...',
    invalidLink: 'Invalid link',
    requestNewMagicLink: 'You can request a new magic link from the login page.',
    magicLinkFooter: 'Magic link - Secure passwordless login'
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome, {name}',
    overview: 'Overview',
    recentScans: 'Recent scans',
    recentActivity: 'Recent Activity',
    statistics: 'Statistics',
    quickActions: 'Quick Actions',
    newScan: 'New scan',
    viewAllScans: 'View all scans',
    totalScans: 'Total scans',
    activeScans: 'Active scans',
    completedScans: 'Completed scans',
    failedScans: 'Failed scans',
    vulnerabilitiesFound: 'Vulnerabilities found',
    criticalVulns: 'Critical vulnerabilities',
    highVulns: 'High vulnerabilities',
    mediumVulns: 'Medium vulnerabilities',
    lowVulns: 'Low vulnerabilities',
    systemHealth: 'System health',
    toolsStatus: 'Tools status',
    cpuUsage: 'CPU usage',
    memoryUsage: 'Memory usage',
    diskUsage: 'Disk usage',
    // Service status
    services: {
      backendApi: 'Backend API',
      frontend: 'Frontend',
      postgresql: 'PostgreSQL',
      aiModels: 'AI Models'
    },
    serviceStatus: {
      online: 'Online',
      offline: 'Offline',
      checking: 'Checking',
      degraded: 'Degraded'
    },
    monitoring: 'Security monitoring and real-time analysis',
    critical: 'crit',
    serverPerformance: 'Server Performance',
    realtimeMonitoring: 'Real-time Monitoring',
    infrastructureTotal: 'Total Infrastructure',
    online: 'Online',
    started: 'Started',
    noActiveScans: 'No active scans. Start a new scan to begin.',
    noRecentActivity: 'No recent activity.',
    startAssessment: 'Start a security assessment',
    exportResults: 'Export scan results',
    uptime: 'Uptime',
    activeProcesses: 'Active Processes',
    scansToday: 'Scans Today',
    networkLoad: 'Network Load',
    temperature: 'Temperature',
    attackTools: {
      reconnaissance: 'Reconnaissance',
      exploitation: 'Exploitation',
      bruteForce: 'Brute Force',
      postExploitation: 'Post-Exploitation',
      privilegeEscalation: 'Privilege Escalation'
    },
    targets: {
      webApps: 'Web Applications',
      servers: 'Servers',
      databases: 'Databases',
      network: 'Network',
      networkDevices: 'Routers, switches',
      target: 'Target'
    },
    resources: {
      high: 'High',
      medium: 'Medium',
      normal: 'Normal',
      critical: 'Critical',
      optimal: 'Optimal',
      active: 'Active',
      inUse: 'In Use',
      idle: 'Idle',
      notDetected: 'Not Detected',
      gpuNotAvailable: 'GPU Not Available',
      aiDisabled: 'AI Disabled',
      cores: 'cores',
      multiCore: 'Multi-core',
      systemLoad: 'System Load',
      used: 'used',
      calculating: 'Calculating...',
      total: 'total',
      totalCores: 'Total Cores',
      totalMemory: 'Total RAM',
      computePower: 'Compute Power',
      ramCapacity: 'RAM Capacity',
      aiCapacity: 'AI Capacity',
      availableTotal: 'Available / Total',
      cpuCores: 'CPU Cores',
      ramInfra: 'Infra. RAM',
      gpuVram: 'GPU VRAM',
      aiReady: 'AI Ready',
      temperatureOk: 'OK',
      servers: 'servers',
      onlineCount: 'online',
      offlineCount: 'offline',
      gpuOnline: 'GPU online',
      model: 'model'
    }
  },

  // Equipment
  equipment: {
    title: 'Equipment Management',
    subtitle: 'Detect, categorize, and attack network equipment',
    totalEquipment: 'Total Equipment',
    totalEquipmentDesc: 'Total number of equipment registered in the database. Includes servers, workstations, network equipment, IoT, OT/ICS and other identified devices.',
    equipmentLabel: 'Equipment',
    totalAttacks: 'Total Attacks',
    attacksLabel: 'attacks',
    successfulAttacks: 'Successful Attacks',
    successfulAttacksLabel: 'successful',
    ongoingAttacks: 'Ongoing Attacks',
    ongoingAttacksLabel: 'ongoing',
    typesTab: 'Equipment Types',
    detectedTab: 'Detected Equipment',
    attacksTab: 'Attacks',
    autoDetect: 'Auto-Detect',
    refresh: 'Refresh',
    searchPlaceholder: 'Search…',
    category: 'Category',
    allCategories: 'All'
  },

  // Scans
  scans: {
    title: 'Scans',
    newScan: 'New scan',
    scanHistory: 'Scan history',
    target: 'Target',
    targets: 'Targets',
    scanType: 'Scan type',
    startScan: 'Start scan',
    stopScan: 'Stop scan',
    pauseScan: 'Pause',
    resumeScan: 'Resume',
    deleteScan: 'Delete scan',
    scanDetails: 'Scan details',
    scanResults: 'Scan results',
    progress: 'Progress',
    duration: 'Duration',
    startedAt: 'Started at',
    completedAt: 'Completed at',
    status: {
      waiting: 'Queued',
      queued: 'Queued',
      pending: 'Pending',
      running: 'Running',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled',
      paused: 'Paused',
      stopped: 'Stopped',
      scheduled: 'Scheduled'
    },
    filters: {
      all: 'All',
      failed: 'Failed'
    },
    types: {
      quick: 'Quick scan',
      full: 'Full scan',
      stealth: 'Stealth scan',
      aggressive: 'Aggressive scan',
      custom: 'Custom scan',
      ai_scan: 'AI Scan',
      iot_scan: 'IoT Scan',
      ot_scan: 'OT/ICS Scan',
      full_autonomous: 'Full Autonomous',
      full_auto: 'Full Autonomous',
      full_automation: 'Full Autonomous',
      network_discovery: 'Network Discovery',
      vulnerability_scan: 'Vulnerability Scan',
      expert: 'Expert Scan',
      api_pentest: 'API Pentest',
      ad_pentest: 'Active Directory Pentest',
      ad_scan: 'Active Directory Scan',
      wifi_pentest: 'Wi-Fi Pentest',
      social_engineering: 'Social Engineering',
      red_team: 'Red Team',
      phishing: 'Phishing Campaign',
      cloud_scan: 'Cloud Scan'
    },
    phases: {
      discovery: 'Discovery',
      portScan: 'Port scan',
      serviceDetection: 'Service detection',
      vulnScan: 'Vulnerability scan',
      exploitation: 'Exploitation',
      reporting: 'Reporting'
    },
    stealthMode: {
      title: 'Stealth Mode',
      description: 'IDS/IPS evasion techniques',
      none: 'None',
      noneDesc: 'Fast scan, easily detectable',
      basic: 'Basic',
      basicDesc: 'Fragmented packets',
      advanced: 'Advanced',
      advancedDesc: 'Slow timing + spoofing',
      paranoid: 'Paranoid',
      paranoidDesc: 'Maximum evasion (very slow)',
      warning: 'Stealth modes use evasion techniques to avoid IDS/IPS detection',
      basicTime: 'The scan will take approximately 2x longer',
      advancedTime: 'The scan will take approximately 5x longer',
      paranoidTime: 'The scan will take approximately 10x longer'
    },
    advancedDiscoveryOptions: 'Advanced discovery options',
    hosts: 'Hosts',
    ports: 'Ports',
    services: 'Services',
    openPorts: 'Open ports',
    closedPorts: 'Closed ports',
    filteredPorts: 'Filtered ports',
    noResults: 'No results found',
    exportResults: 'Export results',
    configureScan: 'Configure detailed scan parameters',
    steps: {
      targetType: 'Target & Type',
      networkMode: 'Network Mode',
      scanOptions: 'Scan Options',
      advanced: 'Advanced',
      review: 'Review'
    },
    allScans: 'All scans',
    activeScans: 'Active scans',
    withSuccess: 'Successfully',
    vulnerabilities: 'Vulnerabilities',
    discovered: 'Discovered',
    toReview: 'To review',
    // Sort options
    sortByDate: 'Sort by date',
    sortByStatus: 'Sort by status',
    sortByVulns: 'Sort by vuln.',
    // Stat card tooltips
    tooltips: {
      totalScans: 'Total Scans',
      totalScansDesc: 'Total number of scans launched on the platform. Includes all scans: running, completed, and failed.',
      runningScans: 'Running Scans',
      runningScansDesc: 'Scans currently executing. They analyze targets to detect open ports, services, and vulnerabilities.',
      completedScans: 'Completed Scans',
      completedScansDesc: 'Scans that completed successfully. Results are available for consultation and export in reports.',
      vulnerabilities: 'Detected Vulnerabilities',
      vulnerabilitiesDesc: 'Total security flaws identified. Badges indicate the number of critical and high vulnerabilities requiring immediate attention.',
      hostsDiscovered: 'Discovered Hosts',
      hostsDiscoveredDesc: 'Number of machines (servers, workstations, network equipment) detected during scans. Each host may have multiple exposed ports and services.',
      failedScans: 'Failed Scans',
      failedScansDesc: 'Failed scans (unreachable target, timeout, network issue). Check details to understand the cause and retry if necessary.'
    },
    notFound: 'Scan not found',
    notFoundDesc: 'The requested scan does not exist or has been deleted',
    backToScans: 'Back to scans',
    scanFailed: 'Scan failed',
    genericError: 'An error occurred during scan execution. This may be due to network connectivity issues, unreachable targets, or insufficient resources.',
    technicalDetails: 'Technical details',
    retryScan: 'Retry this scan',
    // Console labels
    consoleLive: 'Live Console',
    consoleCompleted: 'Console (Completed)',
    consoleFailed: 'Console (Failed)',
    consoleTitle: 'Console',
    scanCompletedMessage: '✓ Completed!',
    scanFailedMessage: '✗ Scan failed',
    // Progress steps
    stepCompleted: 'Completed',
    stepWaiting: 'Waiting',
    stepInProgress: 'Scanning',
    // Timestamp labels
    timestampStarted: 'Started',
    timestampCompleted: 'Completed',
    // Cleanup mode
    cleanup: 'Cleanup',
    cleanupTitle: 'Post-pentest cleanup',
    cleanupDescription: 'This action will remove all traces left by the pentest, including:',
    cleanupSessions: 'Active exploitation sessions',
    cleanupPersistence: 'Installed persistence mechanisms',
    cleanupFiles: 'Temporary files and evidence',
    cleanupLogs: 'APT execution logs',
    cleanupPreview: 'Cleanup preview',
    sessionsCount: 'Sessions',
    withPersistence: 'With persistence',
    aptExecutions: 'APT executions',
    evidenceFiles: 'Evidence files',
    evidenceSize: 'Evidence size',
    cleanNow: 'Clean now',
    archiveAndClean: 'Archive and clean',
    cleaning: 'Cleaning...',
    cleanupSuccess: 'Cleanup completed successfully',
    cleanupPartial: 'Partial cleanup (some errors)',
    cleanupFailed: 'Cleanup failed',
    sessionsClosed: 'Sessions closed',
    persistenceRemoved: 'Persistence removed',
    filesCleaned: 'Files cleaned',
    aptLogsCleaned: 'APT logs cleaned',
    evidenceArchived: 'Evidence archived',
    cleanupWarning: '⚠️ This action is irreversible. Make sure you have saved important data.',
    // AI Quota
    aiQuotaExceeded: 'AI Scan Quota Reached',
    aiScansUsed: 'AI Scans used',
    upgradeOptions: 'Options to continue',
    callSylink: 'Call SYLink customer service:',
    upgradePlan: 'Upgrade to a paid plan for unlimited AI scans',
    viewPlans: 'View plans',
    // Scan types for NewScan wizard
    networkDiscovery: 'Network Discovery',
    networkDiscoveryDesc: 'Fast host and port discovery',
    vulnerabilityScan: 'Vulnerability Scan',
    vulnerabilityScanDesc: 'In-depth vulnerability analysis',
    fullAutonomous: 'Full Autonomous',
    fullAutonomousDesc: 'Complete security assessment',
    searchPlaceholder: 'Search by Target or Type...',
    // Placeholders
    placeholders: {
      target: '192.168.1.0/24 or example.com',
      targetExamples: 'Examples: 192.168.1.1, 192.168.1.0/24, example.com, 10.0.0.0/8',
      customPorts: 'e.g.: 80,443,8080-8090',
      excludeHosts: 'e.g.: 192.168.1.1,192.168.1.5'
    },
    // Table column headers
    table: {
      name: 'Name',
      score: 'Score',
      target: 'Target',
      client: 'Client',
      type: 'Type',
      status: 'Status',
      vulnerabilities: 'Vuln.',
      date: 'Date',
      actions: 'Actions'
    },
    // Additional strings
    noCaptures: 'No captures',
    noLogsAvailable: 'No logs available',
    waitingForLogs: 'Waiting for logs...',
    discoveringHosts: 'Discovering hosts...',
    noHostDiscovered: 'No host discovered',
    analyzingVulns: 'Analyzing vulnerabilities...',
    noVulnDetected: 'No vulnerabilities detected',
    noCriticalVulns: 'No critical vulnerabilities detected.',
    noAttackScenario: 'No critical attack scenario identified.',
    noWeakness: 'No critical weakness detected',
    noContent: 'No content available',
    noData: 'No data available',
    noVpnSession: 'No VPN session is currently active for this workspace.',
    loadingExecutiveReport: 'Loading executive report...',
    saveSchedule: 'Save schedule',
    noActiveScan: 'No scan in progress',
    noScanFound: 'No scan found',
    noScanResult: 'No result for "{query}"',
    noScanStatus: 'No scan with status "{status}"',
    noVulnerabilities: 'No vulnerabilities',
    loadingError: 'Loading error',
    deleteFailedScans: 'Delete failed',
    deleteFailedScansTitle: 'Delete all failed scans',
    confirmDeleteFailed: 'Delete {count} failed scan(s)?',
    deleteScansError: 'Error deleting scans',
    associateScansError: 'Error associating scans',
    removeScansError: 'Error removing scan',
    restartScansError: 'Error restarting scans',
    restartError: 'Error restarting',
    loadScansError: 'Error loading scans',
    networkError: 'Network error. Check your connection and try again.',
    validateScansError: 'Error validating scans',
    imageLoadError: 'Image loading error',
    noWorkspaceForScan: 'No workspace associated with this scan. Please select a client from the Clients page, then restart the scan.',
    pdfGenerationError: 'PDF generation error',
    scheduleSaved: 'Save schedule',
    scheduleError: 'Error creating schedule',
    generatePdfError: 'Error generating PDF',
    errors: {
      createFailed: 'Failed to create scan',
      serverError: 'Server error during scan',
      workspaceRequired: 'Workspace required to start a scan'
    },
    screenshotLoadError: 'Screenshot loading error',
    details: {
      queuedTitle: 'Scan queued',
      queuedDesc: 'Your scan is queued for processing...',
      queuePosition: 'Queue position',
      estimatedWait: 'Estimated wait (minutes)',
      runningScans: 'Running scans',
      statusQueued: 'Queued',
      currentStep: 'Current step',
      statusStarting: 'Starting',
      soon: 'Soon',
      cvssRangeCritical: 'CVSS 9.0-10.0',
      cvssRangeHigh: 'CVSS 7.0-8.9',
      cvssRangeMedium: 'CVSS 4.0-6.9',
      cvssRangeLow: 'CVSS 0.1-3.9',
      riskCritical: 'Immediate action required. High compromise risk.',
      riskHigh: 'Caution recommended. Exploitable vulnerabilities detected.',
      riskMedium: 'Risk under control. Continue monitoring.',
      exitIp: 'Exit IP',
      location: 'Location',
      protocol: 'Protocol',
      upload: 'Upload',
      download: 'Download',
      vulnerabilities: 'Vulnerabilities',
      exposure: 'Exposure',
      configuration: 'Configuration',
      hackProbability: 'Hack Probability',
      advancedAnalysis: 'Advanced Security Analysis',
      advancedAnalysisDesc: 'Detailed CyberScore based on all tools',
      severityBreakdown: 'Severity breakdown',
      mostImpacted: 'Most impacted services',
      aiToolsTitle: 'AI Tools & Threat Intel',
      aiToolsDesc: 'Command generation · Shodan · VirusTotal',
      toolResults: 'Tool Results',
      toolResultsDesc: 'Detailed outputs from each scan tool',
      aiReport: 'AI Executive Report',
      aiAnalyzing: 'The AI is analyzing your target...',
      aiIntelAnalysis: 'AI Intelligence Analysis',
      aiRiskAnalysis: 'AI Risk Analysis',
      hosts: 'Hosts',
      weakPoints: 'Identified weaknesses',
      analyzingIdentities: 'Analyzing identities and access...',
      businessImpactPending: 'Business impact will be calculated...',
      fixCritical: 'Fix critical vulnerabilities',
      fixHigh: 'Fix high vulnerabilities',
      continuousImprovements: 'Continuous improvements',
      positivePointsPending: 'Positive points will be identified...',
      validating: 'Validating...',
      captureConsole: 'Capture console',
      aiRecommendations: 'AI Recommendations',
      correctDetection: 'Correct detection',
      falsePositive: 'False positive / Feedback',
      includeInReport: 'Include in report',
      excludeFromReport: 'Exclude from report',
      sortBySeverity: 'Sort by severity',
      sortByDate: 'Sort by date',
      mostSevereFirst: 'Most severe first',
      mostRecentFirst: 'Most recent first',
      loadingVulns: 'Loading vulnerability details...',
      check: 'Check',
    },
    list: {
      cyberScoreLegend: 'CyberScore Legend',
      scoreExcellent: 'Excellent',
      scoreGood: 'Good',
      scoreMedium: 'Fair',
      scoreLow: 'Poor',
      scoreCritical: 'Critical',
      unassigned: 'Unassigned',
    },
    regenerateReports: 'Regenerate PDF and Word reports',
    activeScanRealtime: 'Active scan - Real-time results',
  },

  // Workspaces
  workspaces: {
    title: 'Client Workspaces',
    subtitle: 'Manage your client workspaces and their configurations',
    newWorkspace: 'New workspace',
    editWorkspace: 'Edit workspace',
    deleteWorkspace: 'Delete workspace',
    deleteWorkspaceError: 'Error deleting workspace',
    deleteWorkspaceSuccess: 'Workspace deleted successfully',
    invalidIdentifier: 'Please enter a valid identifier',
    workspaceDetails: 'Workspace details',
    workspaceName: 'Workspace name',
    clientName: 'Client name',
    clientInfo: 'Client information',
    members: 'Members',
    addMember: 'Add member',
    removeMember: 'Remove member',
    scansCount: 'Scans count',
    lastActivity: 'Last activity',
    created: 'Created on',
    shareWorkspace: 'Share workspace',
    archiveWorkspace: 'Archive workspace',
    noWorkspaces: 'No client workspaces',
    companyName: 'Company name',
    searchCompany: 'Search company',
    postalCode: 'Postal code',
    nafCode: 'NAF code',
    capital: 'Capital',
    employees: 'Employees',
    companyLogo: 'Company logo',
    noLogo: 'No logo',
    vpnConfiguration: 'VPN configuration',
    contractStatus: 'Contract status',
    sendContract: 'Send contract',
    readyForTests: 'Ready for tests',
    upload: 'Upload',
    // Form labels
    siret: 'SIRET',
    siretPlaceholder: 'e.g. 123 456 789 00001',
    siren: 'SIREN',
    sirenPlaceholder: 'e.g. 123 456 789',
    country: 'Country',
    // Additional workspace keys
    scans: 'Scans',
    hosts: 'Hosts',
    vulnerabilities: 'Vulnerabilities',
    attackPaths: 'Attack paths',
    successfulScans: 'Successful scans',
    company: 'Company',
    legalForm: 'Legal form',
    address: 'Address',
    city: 'City',
    website: 'Website',
    shareDescription: 'Share this workspace with your clients or collaborators',
    manageShares: 'Manage shares',
    mainContact: 'Main contact',
    contact: 'Contact',
    signed: 'Signed',
    pending: 'Pending',
    draft: 'Draft',
    contractSigned: 'Contract signed',
    contractNotSigned: 'Contract not signed',
    pendingContract: 'Pending contract',
    noContract: 'No contract',
    noScans: 'No scans associated',
    noScansHint: 'Associate an existing scan or launch a new one from the Scans page',
    noHosts: 'No hosts',
    noVulnerabilities: 'No vulnerabilities',
    noAttackPaths: 'No attack paths',
    // Network stats
    vulnerable: 'Vulnerable',
    subnets: 'Subnets',
    services: 'Services',
    // Contact form labels
    contactFullName: 'Full name',
    contactFunction: 'Function',
    contactEmail: 'Email',
    contactPhone: 'Phone',
    contactResponsibleDescription: 'Person responsible for the pentest project',
    logoUsedInReports: 'Used in pentest reports',
    noAttackTree: 'No attack tree',
    noVPN: 'No VPN configured',
    // AI Analysis
    aiAnalysis: 'AI Analysis',
    generateSummary: 'Generate summary',
    launchAiAnalysis: 'Launch AI analysis',
    analysisInProgress: 'Analysis in progress...',
    completeAnalysis: 'Complete analysis & Solutions',
    aggregatedData: 'Aggregated data',
    riskAnalysis: 'Risk analysis',
    clickToGenerateSummary: 'Click "Generate summary" to get an AI analysis',
    analyzingInProgress: 'Analysis in progress...',
    generatingAiSummary: 'Generating AI summary',
    noScansToAssociate: 'No scans available to associate',
    associateScan: 'Associate a scan',
    networkMap: 'Network Map',
    noAnalysisAvailable: 'No analysis available',
    clickToLaunchAnalysis: 'Click the button above to launch AI analysis',
    launchScanToDiscoverNetwork: 'Run a scan to discover the network',
    critical: 'Critical',
    high: 'High',
    download: 'Download',
    deleteStoredCredentials: 'Delete stored credentials',
    useStoredCredentials: 'use stored credentials',
    enterVpnUsername: 'Enter your VPN username',
    enterVpnPassword: 'Enter your VPN password',
    // VPN Modal
    actionPlan: 'Action Plan & Solutions',
    noDocuments: 'No documents generated for this workspace',
    reportsWillAppear: 'Reports will appear here after generation',
    vpnCredentials: 'VPN Credentials',
    requiresAuthentication: 'requires authentication',
    storedCredentials: 'Stored credentials',
    clickToUseCredentials: 'Click "Connect" to use these credentials',
    connect: 'Connect',
    cancel: 'Cancel',
    username: 'Username',
    password: 'Password',
    saveCredentials: 'Save these credentials',
    saveCredentialsSecurely: 'Save credentials securely',
    credentialsStorageInfo: 'Credentials will be encrypted (AES-256) and stored in the database. They will be automatically used for future VPN connections.',
    saving: 'Saving...',
    connecting: 'Connecting...',
    server: 'Server',
    protocol: 'Protocol',
    noVulnsToFix: 'No vulnerabilities to fix',
    connectionInProgress: 'Connection in progress...',
    connectionFailed: 'Connection failed',
    generateActionPlan: 'Generate action plan',
    clickToGenerateActionPlan: 'Click "Generate action plan" to get recommendations',
    vpnConnected: 'VPN connected! IP:',
    // Workspace Switcher
    select: 'Select workspace',
    selectTitle: 'Select Workspace',
    selectDescription: 'Choose a workspace to continue',
    searchPlaceholder: 'Search workspaces...',
    noWorkspacesYet: 'No workspaces yet',
    noResults: 'No matching workspaces',
    createFirst: 'Create your first workspace',
    createNew: 'Create New',
    manageAll: 'Manage Workspaces',
    continue: 'Continue',
    switchError: 'Failed to switch workspace',
    switchSuccess: 'Workspace switched successfully',
    // Schedules
    scanSchedules: 'Scan Schedules',
    addSchedule: 'Add Schedule',
    noSchedules: 'No schedules configured',
    noSchedulesHint: 'Click "Add Schedule" to automate your scans',
    createSchedule: 'Create Schedule',
    scheduleName: 'Schedule name',
    scheduleNamePlaceholder: 'e.g.: Weekly security scan',
    targets: 'Targets',
    targetsPlaceholder: '192.168.1.0/24, example.com',
    targetsCommaSeparated: 'Targets * (comma-separated)',
    scanType: 'Scan type',
    frequency: 'Frequency',
    timeOfDay: 'Time of day',
    daysOfWeek: 'Days of the week',
    autoGenerateReport: 'Auto-generate report',
    sendNotifications: 'Send notifications',
    notificationRecipients: 'Notification recipients (emails, comma-separated)',
    creating: 'Creating...',
    // Scan types
    scanTypeQuick: 'Quick',
    scanTypeFull: 'Full',
    scanTypeVulnerability: 'Vulnerability',
    scanTypePortScan: 'Port Scan',
    scanTypeWebScan: 'Web Scan',
    // Frequencies
    frequencyDaily: 'Daily',
    frequencyWeekly: 'Weekly',
    frequencyBiweekly: 'Biweekly',
    frequencyMonthly: 'Monthly',
    frequencyQuarterly: 'Quarterly',
    // Stats labels
    schedulesCount: 'Schedules',
    successfulRuns: 'Successful runs',
    runNow: 'Run now',
    // Days of week (Monday-first to match backend convention)
    dayMon: 'Mon',
    dayTue: 'Tue',
    dayWed: 'Wed',
    dayThu: 'Thu',
    dayFri: 'Fri',
    daySat: 'Sat',
    daySun: 'Sun',
    nextRun: 'Next',
    // Remediation Tracker
    remediationTitle: 'Remediation Tracker',
    remediationProgress: 'Overall progress',
    remediationVulnsFixed: 'vulnerabilities remediated',
    remediationNoVulns: 'No vulnerabilities found',
    remediationRescanTitle: 'Launch a re-scan for verification',
    remediationAllStatuses: 'All statuses',
    remediationAllSeverities: 'All severities',
    remediationResults: 'results',
    remediationSeverity: 'Severity',
    remediationVulnerability: 'Vulnerability',
    remediationHost: 'Host',
    remediationStatus: 'Status',
    remediationUpdated: 'Updated',
    remediationActions: 'Actions',
    remediationPrevious: '← Previous',
    remediationNext: 'Next →',
    remediationCritical: 'Critical / High — unresolved',
    remediationSeverityBreakdown: 'Breakdown by severity',
    remediationStatusUpdate: 'Status updated',
    remediationStatusError: 'Error updating status',
    remediationLoadDashboardError: 'Error loading dashboard',
    remediationLoadVulnsError: 'Error loading vulnerabilities',
    remediationRefresh: 'Refresh',
    remediationCertificate: 'Closure certificate',
    remediationSearch: 'Search...',
    // Status labels
    statusOpen: 'Open',
    statusInProgress: 'In progress',
    statusFixed: 'Fixed (to verify)',
    statusVerified: 'Verified ✓',
    statusAcceptedRisk: 'Accepted risk',
    statusWontFix: 'Will not be fixed',
    // Severity labels
    severityCritical: 'Critical',
    severityHigh: 'High',
    severityMedium: 'Medium',
    severityLow: 'Low',
    severityInfo: 'Info',
    // KPI labels
    kpiOpen: 'Open',
    kpiInProgress: 'In progress',
    kpiToVerify: 'To verify',
    kpiVerified: 'Verified',
    kpiAcceptedRisk: 'Accepted risk',
    kpiTotal: 'Total',
    // VPN
    saveUid: 'Save UID',
    noVpnCredentials: 'No VPN credentials saved — connect to save some',
    noVpnRoutes: 'No custom routes configured',
    add: 'Add',
    noScanReports: 'No scan reports available',
    errorAnalysis: 'Analysis error',
    noBusinessAnalysis: 'No business analysis available',
    remediationTracker: 'Remediation tracker',
    downloadAsPdf: 'Download as PDF',
    downloadAsWord: 'Download as Word',
    downloadGeoipReport: 'Download GeoIP report',
    geoipComplianceReport: 'GeoIP & Compliance Report',
    riskCartographyReport: 'Risk Cartography Report',
    ipGeolocation: 'IP Geolocation',
    countryRisks: 'Country risks',
    hackerGroups: 'Hacker groups',
    min2ScansRequired: 'Minimum 2 completed scans required',
    launchRegularScans: 'Launch regular scans to track risk evolution',
    firstScan: 'First scan:',
    lastScan: 'Last scan:',
    generatedOn: 'Generated on',
    connected: 'Connected',
    disconnected: 'Disconnected',
    accessible: 'Accessible',
    notAccessible: 'Not accessible',
    online: 'Online',
    offline: 'Offline',
    notConnected: 'Not connected',
    markAsFalsePositive: 'Mark as false positive',
    removeFalsePositive: 'Remove false positive',
    downloadAsWordTooltip: 'Download as Word',
    improvement: 'Improvement',
    degradation: 'Degradation',
    stable: 'Stable',
    aiGeneratedReports: 'AI Generated Reports',
    since: 'Since',
    noVpnConfig: 'No VPN configuration',
    deleteReport: 'Delete report',
    vpnRouteCount: '{{count}} route(s)',
    noRoutes: 'No routes',
    // WorkspaceManager
    deleteVpnLogo: 'Delete logo',
    modifyWorkspace: 'Edit workspace',
    modifyWorkspaceDesc: 'Edit client information "{{name}}"',
    modifyVpnDesc: 'Edit the VPN associated with scans for this client',
    noVpnRequired: 'No VPN configuration required',
    noVpnAvailable: 'No VPN configuration available',
    createWorkspaceBtn: 'Create workspace',
    vpnUploadError: 'Error uploading VPN',
    companyNotFound: 'No company found for "{{term}}"',
    noCompanyFound: 'No company found',
    companySearchError: 'Error during search',
    scheduleError: 'Error scheduling scan',
    noCompletedScans: 'No completed scans',
    allWorkspaces: 'All workspaces',
    contractCreateError: 'Error creating contract',
    // Business context details
    details: {
      analyzed: 'Analyzed',
      analyzing: 'Analyzing...',
      analyzeWithAI: 'Analyze with AI',
      aiAnalysisInProgress: 'AI analysis in progress...',
      business: 'Business',
      estimatedSize: 'Estimated size: ',
      cyberImpacts: 'Cyber Impacts',
      dataSensitivity: 'Data sensitivity:',
      keyServices: 'Key services',
      pentestFocus: 'Pentest focus tailored to business',
      cyberattackImpact: 'Cyberattack impact',
      gdprFine: 'Max. estimated GDPR fine',
      category: 'Category',
      reanalyze: 'Re-analyze',
      enterUrlHint: 'Enter the website URL and click "Analyze with AI"',
      destinationCidr: 'Destination (CIDR)',
      gateway: 'Gateway',
      active: 'Active',
    },
    infoLoaded: '{source} information loaded',
    tabCompany: 'Company',
    tabContact: 'Contact',
    tabLogo: 'Logo',
    tabVpn: 'VPN',
    tabContract: 'Contract',
    newClientWorkspace: 'New Client / Workspace',
    newClientDesc: 'Add a new client with business registry search',
    authRequired: 'Auth required',
    vpnCredentialsRequired: 'VPN credentials required',
    usernameLabel: 'Username',
    passwordLabel: 'Password',
    addOvpnFiles: 'Add .ovpn files in settings',
    selectScanOrName: 'Please select a scan or enter a name',
    selectWorkspaceFirst: 'Please select a workspace',
    scanScheduledOk: 'Scan scheduled successfully',
    routeAdded: 'Route added successfully',
    routeDeleted: 'Route deleted',
    fillDestGateway: 'Please fill in destination and gateway',
    topVulnerabilities: 'Top vulnerabilities',
    workflowView: 'Workflow view',
    listView: 'List view',
    generatingAttackTree: 'Generating attack tree…',
    fileSelected: '{name} file "{filename}" selected',
    vpnUploadSuccess: '{name} configuration uploaded successfully',
  },

  // Workspace (alias for workspace switcher)
  workspace: {
    select: 'Select Workspace',
    selectTitle: 'Select Workspace',
    selectDescription: 'Choose a workspace to continue',
    searchPlaceholder: 'Search workspaces...',
    noWorkspaces: 'No workspaces available',
    noWorkspacesYet: 'No workspaces yet',
    noResults: 'No matching workspaces',
    createFirst: 'Create your first workspace',
    createNew: 'Create New',
    manageAll: 'Manage Workspaces',
    continue: 'Continue',
    switchError: 'Failed to switch workspace',
    switchSuccess: 'Workspace switched successfully',
    scan: 'scan',
    scans: 'scans',
    createRequired: 'Workspace Required',
    createRequiredDescription: 'You need a workspace to access this section. Create your first workspace to continue.',
    selectRequired: 'Select a Workspace',
    selectRequiredDescription: 'Please select a workspace to access this section. You have',
    workspaceAvailable: 'workspace available.',
    workspacesAvailable: 'workspaces available.',
    selectWorkspace: 'Select Workspace'
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Vulnerabilities',
    subtitle: 'Analysis and management of detected vulnerabilities',
    aiExploitRecommendations: 'AI Exploit Recommendations',
    aiExploitGenerator: 'AI Exploit Generator',
    exploitsAvailable: 'Available exploits',
    searchingMetasploitDb: 'Searching Metasploit, Exploit-DB databases...',
    clickViewToSearchExploits: 'Click "View" to search for available exploits',
    thenLaunchToTest: 'Then "Launch" to test on the target',
    searchInMetasploitEtc: 'Search in Metasploit, Exploit-DB, NVD, PacketStorm',
    executedLabel: 'Executed',
    aiAssistant: 'AI Assistant',
    aiAssistantDesc: 'Analyze and exploit vulnerabilities autonomously',
    vulnerability: 'Vulnerability',
    severity: 'Severity',
    severities: {
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      info: 'Informational'
    },
    cve: 'CVE',
    cvss: 'CVSS Score',
    affected: 'Affected',
    solution: 'Solution',
    references: 'References',
    evidence: 'Evidence',
    exploitable: 'Exploitable',
    verified: 'Verified',
    falsePositive: 'False positive',
    validation: {
      confirmed: 'Confirmed exploitable',
      theoretical: 'Theoretical',
      not_exploitable: 'Not exploitable',
      unvalidated: 'Unvalidated',
      poc_title: 'Proof of Concept',
      narrative: 'Exploitation narrative',
      exploit_path: 'Exploit path',
      prerequisites: 'Prerequisites',
    },
    markAsFixed: 'Mark as fixed',
    noVulnerabilities: 'No vulnerabilities found',
    export: 'Export vulnerabilities',
    distributionBySeverity: 'Distribution by Severity',
    details: {
      loading: 'Loading vulnerability details...',
      exploitProof: 'Exploit Proof',
    },
    priority: {
      auto: 'Automatic',
    },
    searchPlaceholder: 'Search by title, CVE, description...',
    noVulnerabilitiesFound: 'No vulnerabilities found in scans.',
    noVulnerabilitiesBySeverity: 'No vulnerabilities with severity {severity} found.',
    customActionPlaceholder: 'e.g.: reverse_shell, creds_extraction, backdoor...',
    // Action Panel
    actionPanel: {
      title: 'Actions on vulnerability',
    },
    // Attack Chain
    attackChain: {
      title: 'Attack Chain Ranking',
      analysisTitle: 'Risk Analysis',
      subtitle: 'Multi-vulnerability risk analysis for target penetration',
      riskScore: 'Risk score',
      vulnCount: 'vulnerabilities',
      attackPath: 'Attack path to objective',
      // Chart
      chartTitle: 'Vulnerability Distribution',
      chartSubtitle: 'Statistical analysis of detected CVEs',
      bySeverity: 'Distribution by Severity',
      keyMetrics: 'Key Metrics',
      totalVulns: 'Total CVE',
      avgCvss: 'Average CVSS',
      criticalHigh: 'Critical + High',
      affectedHosts: 'Affected Hosts',
      topCves: 'Top CVE by CVSS',
      // Stages
      stages: {
        initialAccess: 'Initial Access',
        privEscalation: 'Privilege Escalation',
        persistence: 'Persistence',
        objective: 'Objective'
      },
      exploitVia: 'Exploitation via',
      escalationVia: 'Escalation via',
      maintenanceVia: 'Persistence via',
      fullCompromise: 'Full system compromise',
      adminAccess: 'Admin access possible',
      initialSystemAccess: 'Initial system access',
      // Risk Factors
      riskFactors: 'Risk factors',
      factors: {
        multiVuln: 'Multi-vulnerabilities',
        multiVuln5: '{count} chainable vulns',
        multiVuln3: '{count} vulns on this host',
        criticalHighCombo: 'Critical + High combo',
        rce: 'Potential RCE',
        authBypass: 'Auth bypass possible',
        privEsc: 'Privilege escalation',
        exposed: 'Exposed services',
        highCvss: 'Average CVSS {score}'
      },
      // Ratings
      ratingCritical: 'CRITICAL',
      ratingHigh: 'HIGH',
      ratingMedium: 'MEDIUM',
      ratingLow: 'LOW',
      ratingSafe: 'SAFE',
      // Details
      criticalPath: 'CRITICAL PATH',
      vulnsInChain: 'Vulnerabilities in this chain',
      noChains: 'No attack chains detected',
      noVulnsDesc: 'No vulnerabilities found to analyze attack paths.',
      viewDetails: 'View details',
      multiVulnWarning: 'Increased risk: multiple chainable vulnerabilities',
      // Recommendations
      recommendation: 'Exploitation recommendation',
      recoCritical: 'This target presents a critical risk. The combination of {count} vulnerabilities allows full system compromise. Maximum priority for remediation.',
      recoHigh: 'High risk of compromise. Combined vulnerabilities offer a viable attack path. Corrective action recommended as soon as possible.',
      recoMedium: 'Moderate risk. Some vulnerabilities could be chained for exploitation. Monitor and fix according to priority.',
      recoLow: 'Low risk. Present vulnerabilities have limited impact and are difficult to chain exploit.',
      // Stats
      criticalPaths: 'Critical Paths',
      highRisk: 'High Risk',
      multiVuln: 'Multi-Vulns (3+)',
      hostsAnalyzed: 'Hosts Analyzed',
      avgScore: 'Average Score',
      // Info
      infoText: 'This ranking identifies the most vulnerable hosts by analyzing exploitable vulnerability combinations to achieve penetration objectives.',
      // Legend
      legendCritical: 'Critical (80-100)',
      legendHigh: 'High (60-79)',
      legendMedium: 'Medium (40-59)',
      legendLow: 'Low (20-39)',
      legendSafe: 'Safe (0-19)'
    },
    // AI Quick Actions panel
    prioritization: 'Prioritization',
    prioritizationDesc: 'Urgency and criticality',
    exploitabilityLabel: 'Exploitability',
    exploitabilityDesc: 'Exploitable flaws',
    summaryLabel: 'Summary',
    summaryDesc: 'Overview',
    remediationLabel: 'Remediation',
    remediationDesc: 'Correction plan',
    aiQueryPlaceholder: 'Ask a question about vulnerabilities...',
    analyzeBtn: 'Analyze',
    // PoC Panel
    pocAutoTitle: 'Auto PoC - Generation and Execution',
    pocSelectVuln: 'Select a vulnerability',
    noCriticalHighForPoC: 'No critical/high vulnerability for PoC',
    pocGeneratedCode: 'Generated PoC Code',
    copyCta: 'Copy',
    executeBtn: 'Execute',
    executingBtn: 'Executing...',
    pocGenerating: 'Generating PoC...',
    pocSelectPrompt: 'Select a vulnerability to generate a PoC',
    pocResult: 'Result:',
    pocActionInProgress: 'Action in progress...',
    // Attack Tree
    hideAttackTree: 'Hide Attack Tree',
    showAttackTree: 'Show Attack Tree',
    viewWorkspace: 'View Workspace',
    generatingAttackTree: 'Generating attack tree...',
    noAttackTreeData: 'No data available for attack tree',
    ensureWorkspaceHasScans: 'Make sure the workspace has scans with vulnerabilities',
    // Pagination
    pageOfTotal: 'Page {current} / {total} — {count} vulnerabilities',
    prevPage: '← Previous',
    nextPage: 'Next →',
    // Right panel - Actions
    quickActionsTitle: 'Quick Actions',
    newScanBtn: 'New scan',
    generateReportBtn: 'Generate report',
    exportJsonBtn: 'Export JSON',
    exportCsvBtn: 'Export CSV',
    // AI Analysis panel
    aiAnalysisTitle: 'AI Analysis',
    selectedLabel: 'Selected:',
    analyzingLabel: 'Analyzing...',
    analyzeWithAI: 'Analyze with AI',
    impactLabel: 'Impact',
    recommendationsLabel: 'Recommendations',
    selectVulnForAnalysis: 'Select a vulnerability for a detailed AI analysis.',
    // Statistics panel
    statisticsTitle: 'Statistics',
    cvssAvg: 'Average CVSS',
    exploitableCount: 'Exploitable',
    hostsAffected: 'Affected Hosts',
    // Actions History
    actionsHistory: 'Actions History ({count})',
    clearHistory: 'Clear history',
    viewScan: 'View scan',
    addToReport: 'Add to report',
    // Action Panel Modal
    severityLabel: 'Severity',
    cveLabel: 'CVE',
    cvssLabel: 'CVSS',
    targetLabel: 'Target',
    noDescription: 'No description available',
    clickToChangePriority: 'Click to change priority',
    platform: 'Platform',
    payload: 'Payload',
    clickToSeeDetails: 'Click to see details and captures',
    sessionId: 'Session ID',
    actionsAvailable: 'Available actions',
    exploitAction: 'Exploitation',
    exploitActionDesc: 'Attempt to exploit this vulnerability to gain access',
    injectionAction: 'Injection',
    injectionActionDesc: 'Execute an injection (SQL, command, XSS, etc.)',
    enumerationAction: 'Enumeration',
    enumerationActionDesc: 'Collect more information about this flaw',
    privescAction: 'Elevation',
    privescActionDesc: 'Attempt a privilege escalation',
    pivotAction: 'Pivot',
    pivotActionDesc: 'Pivot to other systems on the network',
    exfilAction: 'Extraction',
    exfilActionDesc: 'Extract sensitive data through this flaw',
    aiWizardBtn: 'AI Wizard',
    aiWizardDesc: 'AI analyzes the CVE and launches the appropriate exploitation wizard',
    captureProofBtn: 'Capture Proof',
    captureProofDesc: 'Capture exploitation proof for the report',
    customActionTitle: 'Custom action',
    executeAction: 'Execute',
    actionsAutoIntegrated: 'Action results will be automatically integrated into the scan report',
    // Priority Modal
    editPriority: 'Edit Priority',
    autoSeverity: 'Automatic severity:',
    manualPriority: 'Manual priority',
    usesCVSS: 'Uses CVSS',
    priorityCritical: 'Critical',
    priorityHigh: 'High',
    priorityMedium: 'Medium',
    priorityLow: 'Low',
    priorityInfo: 'Info',
    noteOptional: 'Note (optional)',
    explainPriorityChange: 'Explain why you changed the priority...',
    savePriority: 'Save',
    savingPriority: 'Saving...',
    // AI Wizard Modal
    aiWizardTitle: 'AI Wizard - Vulnerability Analysis',
    wizardRecommended: 'Wizard recommended by AI',
    vulnSummaryTitle: 'Vulnerability summary',
    launchWizard: 'Launch {name}',
    orChooseWizard: 'Or choose another wizard:',
    aiAnalyzing: 'AI analysis in progress...',
    aiDeterminingWizard: 'AI is determining the best exploitation wizard',
    // Screenshots Panel
    screenshotsTitle: 'Proof Captures ({count})',
    noScreenshots: 'No proof captures',
    screenshotsAutoAdded: 'Captures will be automatically added to reports',
    // Wizard reasons
    wizardReasonAD: 'This vulnerability is linked to Active Directory, Kerberos or Windows services. The AD wizard allows exploiting authentication flaws and lateral movement.',
    wizardReasonAPI: 'This vulnerability concerns an API or web service. The API wizard allows testing endpoints, authentication and injections.',
    wizardReasonIoT: 'This vulnerability affects an IoT device or industrial protocol. The IoT wizard specializes in connected device analysis.',
    wizardReasonOT: 'This vulnerability concerns an industrial or SCADA system. The OT wizard is designed for secure analysis of industrial environments.',
    wizardReasonExpert: 'This critical vulnerability requires in-depth analysis. Expert mode offers full control over exploitation techniques.',
    wizardReasonAI: 'AI will analyze this vulnerability and automatically determine the best exploitation strategy.',
    // AI Analysis generated content
    aiSummaryTemplate: 'This {severity} vulnerability affects {target}. It potentially allows an attacker to exploit {title}.',
    aiImpactCritical: 'Critical impact on system confidentiality and integrity',
    aiImpactHigh: 'High impact - requires immediate attention',
    aiImpactMedium: 'Moderate impact - to be fixed promptly',
    aiImpactLow: 'Low impact - to be monitored',
    aiRec1: 'Apply available security patches',
    aiRec2: 'Restrict network access to the affected service',
    aiRec3: 'Set up enhanced monitoring',
    aiRec4CVE: 'Consult CVE details: {cve_id}',
    aiRec4NoCVE: 'Perform an in-depth analysis',
    aiExploitHigh: 'High',
    aiExploitMedium: 'Medium',
    aiExploitLow: 'Low',
    aiExploitUnknown: 'Not evaluated',
    aiVectorRemote: 'Network (Remote)',
    aiVectorAdjacent: 'Adjacent',
    aiVectorLocal: 'Local',
    // VulnerabilityDetails page extra keys
    exploitabilityMetric: 'Exploitability',
    attackDifficulty: 'Attack Difficulty',
    detectionRisk: 'Detection Risk',
    exploitMaturity: 'Exploit Maturity',
    riskAssessment: 'Risk Assessment',
    aiRecommendations: 'AI Recommendations',
    aiAnalyzingVuln: 'AI is analyzing the vulnerability...',
    clickToGetRecommendations: 'Click on "View" to get AI recommendations',
    autoAnalysisDesc: 'Automatic analysis of attack vectors and exploitation strategies',
    analyzeLabel: 'Analyze...',
    viewLabel: 'View',
    // Exploit generation
    generateExploit: 'Generate',
    generatingExploit: 'Generating...',
    executeOnTarget: 'Execute on target',
    executingExploit: 'Executing...',
    copyCode: 'Copy',
    codeCopied: 'Code copied to clipboard!',
    langLabel: 'Language:',
    targetLabel2: 'Target:',
    aiGeneratingExploit: 'AI is generating a custom exploit...',
    aiExploitAnalysisDesc: 'CVE analysis, payload creation, optimization...',
    clickGenerateExploit: 'Click on "Generate" to create a custom AI exploit',
    thenExecuteExploit: 'Then "Execute on target" to launch the attack',
    autoExploitGenDesc: 'Automatic generation of exploitation code adapted to the target',
    exploitProofs: 'Exploitation Proofs ({count})',
    captureN: 'Capture {n}:',
    capturesEnregistrees: '{count} proof captures recorded',
    exploitReussie: 'EXPLOITATION SUCCESSFUL',
    exploitEchec: 'FAILED',
    dureeDuration: 'Duration',
    exportPdf: 'Export PDF',
    // Impact Analysis Table
    impactAnalysis: 'Impact Analysis',
    accessVector: 'Access Vector',
    accessComplexity: 'Access Complexity',
    requiredAuth: 'Required Authentication',
    userInteractionLabel: 'User Interaction',
    confidentialityImpact: 'Impact on Confidentiality',
    integrityImpact: 'Impact on Integrity',
    availabilityImpact: 'Impact on Availability',
    networkInternet: 'Internet Network',
    adjacentNetwork: 'Adjacent Network',
    localAccess: 'Local Access',
    complexityLow: 'Low',
    complexityHigh: 'High',
    privNone: 'None',
    privLow: 'Low privileges',
    privHigh: 'High privileges',
    userInteractionNone: 'None required',
    userInteractionRequired: 'Required',
    impactFull: 'Complete',
    impactPartial: 'Partial',
    impactNone: 'None',
    scoreCvss: 'CVSS v3.1 Score',
    // AI Recommendations section
    detailsBtn: 'Details',
    launchBtn: 'Launch',
    relaunchBtn: 'Relaunch',
    analyzingLabel2: 'Analyzing...',
    // Remediation section
    remediationRecommendedDelay: 'Recommended Delay',
    remediationMaxWindow: 'Maximum correction window',
    remediationImpact: 'Impact',
    remediationHighImpact: 'HIGH',
    remediationRestartRequired: 'Service restart required',
    remediationStepsTitle: 'Detailed remediation steps',
    // Remediation Steps
    step1Title: 'Backup and preparation',
    step1Desc: 'Before any modification, perform a complete system backup.',
    step1Li1: 'Check available disk space',
    step1Li2: 'Document current configuration',
    step1Li3: 'Notify the concerned teams',
    step2Title: 'Update Apache Struts',
    step2Desc: 'Download and install the latest secure version of Apache Struts.',
    step2Warning: 'Warning: Verify compatibility with your application before updating',
    step3Title: 'WAF Configuration',
    step3Desc: 'Implement WAF rules to block OGNL exploitation attempts.',
    step4Title: 'Configuration Hardening',
    step4Desc: 'Strengthen Struts configuration to prevent future vulnerabilities.',
    step5Title: 'Restart and Validation',
    step5Desc: 'Restart services and validate that the fix is effective.',
    step5Li1: 'Verify that the application starts correctly',
    step5Li2: 'Test critical functionalities',
    step5Li3: 'Relaunch a vulnerability scan to confirm',
    step6Title: 'Monitoring and Surveillance',
    step6Desc: 'Set up continuous monitoring to detect exploitation attempts.',
    step6Li1: 'Configure IDS/IPS alerts for Struts attack patterns',
    step6Li2: 'Enable detailed HTTP request logging',
    step6Li3: 'Schedule regular vulnerability scans (weekly)',
    step6Li4: 'Subscribe to Apache Struts security bulletins',
    workaroundTitle: 'Temporary solution (if patching not possible)',
    workaroundDesc: 'If immediate update is not possible, apply these mitigation measures:',
    workaround1: 'Block external access to the service (firewall/ACL)',
    workaround2: 'Implement a reverse proxy with Content-Type header filtering',
    workaround3: 'Disable non-essential REST endpoints',
    workaround4: 'Enable strict multipart parser mode',
    // Slider
    attackDetails: 'Attack Details',
    targetInfo: 'Target',
    systemInfoTitle: 'System Information',
    hostnameLabel: 'Hostname',
    architectureLabel: 'Architecture',
    ipLabel: 'IP Address',
    initialUserLabel: 'Initial User',
    privilegesObtained: 'Privileges Obtained',
    domainLabel: 'Domain',
    exfiltratedData: 'Exfiltrated Data ({count})',
    proofCaptures: 'Proof Captures ({count})',
    // AI Responses
    aiResponsesCount: '{count} AI response(s)',
    questionLabel: 'Question:',
    // discoveredField
    discoveredField: 'Discovered',
    // Exploit action alerts
    aiExecAlert: 'AI recommendation execution on {host}:{port}\n\nAutomated penetration test launched\nVulnerability scan in progress\nAttack vector verification\n\nResults available in a few minutes...',
    exploitSearchAlert: 'Exploit search and test on {host}:{port}\n\nConnecting to Metasploit Framework\nScanning applicable modules\nAutomated exploit testing\n\n3 exploits found, testing in progress...',
    exploitGenAlert: 'AI exploit generation and execution on {host}:{port}\n\nVulnerability analysis\nCustom payload generation\nExecution on target\n\nResult: Exploitation successful!\nSession established.',
    // Mock screenshot titles
    screenshotInitialConn: 'Initial Connection',
    screenshotInitialConnDesc: 'Establishing reverse shell connection',
    screenshotSysInfo: 'System Information',
    screenshotSysInfoDesc: 'Retrieving target system information',
    screenshotFileAccess: 'File Access',
    screenshotFileAccessDesc: 'Proof of filesystem access',
    attackComplexity: 'Attack Complexity',
    attackVector: 'Attack Vector',
    backToList: 'Back to list',
    cvssMetrics: 'CVSS Metrics',
    exportCsv: 'Export CSV',
    exportJson: 'Export JSON',
    host: 'Host',
    immediateFix: 'Immediate fix',
    noCVE: 'No CVE',
    port: 'Port',
    privilegesRequired: 'Privileges Required',
    remediation: 'Remediation',
    remediationSummary: 'Remediation Summary',
    service: 'Service',
    sortByCvss: 'Sort by CVSS',
    sortBySeverity: 'Sort by severity',
    userInteraction: 'User Interaction',
    screenshotPrivEsc: 'Privilege Escalation',
    screenshotPrivEscDesc: 'Privilege escalation attempt',
    list: {
      attackChain: '⚔️ Attack Chain',
      aiAssistant: '🤖 AI Assistant',
      pocAuto: '💥 Auto PoC',
      total: 'Total Vulnerabilities',
      avgScore: 'Average score',
      avgCvssScore: 'Average CVSS Score',
      uniqueHosts: 'Unique hosts',
      affectedHosts: 'Affected Hosts',
      radarChart: 'Spider Chart (Radar)',
    },
  },

  // Reports
  reports: {
    title: 'Reports',
    newReport: 'New report',
    generateReport: 'Generate report',
    downloadReport: 'Download report',
    reportType: 'Report type',
    settings: 'Settings',
    branding: 'Branding',
    types: {
      executive: 'Executive report',
      technical: 'Technical report',
      compliance: 'Compliance report',
      full: 'Full report',
      vulnerability_list: 'Vulnerability report',
      redteam: 'Red Team report',
      retest: 'Retest report',
      multi_campaign: 'Multi-campaign report',
      active_directory: 'Active Directory report',
      data_leak: 'Data leak report',
      attack_surface: 'Attack surface report'
    },
    typeDescriptions: {
      executive: 'Strategic summary for executives with key indicators and priority recommendations',
      technical: 'Complete vulnerability analysis with technical details and remediations',
      vulnerability_list: 'Structured export for Jira, ServiceNow, GLPI',
      redteam: 'Attack narrative with MITRE ATT&CK mapping',
      retest: 'Before/after fix comparison',
      multi_campaign: 'Consolidated view of multiple scans',
      active_directory: 'AD audit, privileges, GPO, delegations',
      data_leak: 'Detection of exposed data and credentials',
      attack_surface: 'External exposure mapping'
    },
    format: 'Format',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Text (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Include evidence',
    includeRemediation: 'Include remediation',
    generatedAt: 'Generated at',
    generatedBy: 'Generated by',
    noReports: 'No reports',
    // AI Generated Reports
    aiGenerated: 'AI Reports',
    generated: {
      title: 'AI Generated Reports',
      subtitle: 'Professional LLM-powered reports',
      create: 'Create report',
      createNew: 'New AI report',
      selectType: 'Report type',
      selectScan: 'Select a scan',
      selectWorkspace: 'Select a workspace',
      selectFormat: 'Output format',
      generating: 'Generating...',
      regenerate: 'Regenerate',
      regenerateSection: 'Regenerate this section',
      export: 'Export',
      download: 'Download',
      delete: 'Delete',
      confirmDelete: 'Are you sure you want to delete this report?',
      status: {
        pending: 'Pending',
        queued: 'Queued',
        generating: 'Generating',
        completed: 'Completed',
        failed: 'Failed',
        cancelled: 'Cancelled'
      },
      sections: {
        executive_summary: 'Executive summary',
        key_findings: 'Key findings',
        recommendations: 'Recommendations',
        technical_details: 'Technical details',
        vulnerability_analysis: 'Vulnerability analysis',
        risk_assessment: 'Risk assessment',
        remediation_plan: 'Remediation plan',
        attack_narrative: 'Attack narrative',
        mitre_mapping: 'MITRE ATT&CK mapping',
        timeline: 'Timeline',
        appendix: 'Appendix'
      },
      quality: {
        score: 'Quality score',
        excellent: 'Excellent',
        good: 'Good',
        average: 'Average',
        poor: 'Poor'
      },
      noReports: 'No generated reports',
      noReportsDesc: 'Create your first AI report to get started',
      totalReports: 'Total reports',
      completedReports: 'Completed reports',
      averageQuality: 'Average quality',
      lastGenerated: 'Last generated'
    },
    // GeneratedReportDetail keys
    fixRate: 'Fix rate',
    fixed: 'Fixed',
    partial: 'Partial',
    notFixed: 'Not fixed',
    qualityScore: 'Quality Score',
    riskLevel: 'Risk Level',
    riskScore: 'Risk Score',
    aiVerification: 'AI Verification',
    tokensUsed: 'Tokens used: ',
    generationTime: 'Generation time: ',
    keyFindings: 'Key Findings',
    mitreMapping: 'MITRE ATT&CK Mapping',
    vulnStats: 'Vulnerability Statistics',
    remediationProgress: 'Remediation Progress',
    confirmDelete: 'Are you sure you want to delete this report?',
    reportNotFound: 'Report not found',
    backToList: 'Back to list',
    backToReports: 'Back to reports',
    generating: 'Generating...',
    verified: 'verified',
    corrections: 'correction(s) applied',
    executiveSummary: 'Executive Summary',
    attackVectors: 'Attack Vectors',
    complianceImpact: 'Compliance Impact',
    promptVersion: 'Prompt version',
    regenerateReports: 'Regenerate PDF and Word reports',
    // ReportsList keys
    promptIa: 'AI Prompt',
    aiReports: 'AI Reports',
    validationRequired: 'Validation required to generate reports',
    validationRequiredDesc: 'To generate a report, you must first validate items from their respective pages:',
    validationRequiredDesc2: 'Only validated items will appear in the list below.',
    withoutScanData: 'Without scan data',
    linkToScanOptional: 'Link to a scan (optional)',
    noValidScans: 'No valid scans',
    noValidScansDesc: 'Validate your scans from the Scans page',
    totalScansTooltip: 'Total number of security scans performed. This data forms the basis for pentest report generation.',
    totalVulnsTooltip: 'Total vulnerabilities detected across all levels. Includes Critical, High, Medium and Low.',
    criticalVulnsTooltip: 'Critical security flaws (CVSS 9-10). Immediate exploitation possible, total compromise risk. Priority fix within 24-48h.',
    highVulnsTooltip: 'High security flaws (CVSS 7-8.9). Significant impact on confidentiality or integrity. Recommended fix within 2 weeks.',
    mediumVulnsTooltip: 'Medium security flaws (CVSS 4-6.9). Exploitation requires specific conditions. Fix in normal maintenance cycle.',
    lowVulnsTooltip: 'Low impact security flaws (CVSS 0.1-3.9). Limited risk, can be chained with other vulnerabilities. Schedulable fix.',
    generatedReportsTooltip: 'Number of pentest reports generated and saved. Reports include findings, recommendations and can be exported to PDF.',
    enterpriseFeature: 'Enterprise Feature',
    prepareRemediation: 'Prepare Remediation',
    aiAssisted: 'AI Assisted',
    analyzingVulnerabilities: 'Analyzing vulnerabilities...',
    generatingE3rProcedures: 'Generating E3R procedures...',
    aiEnrichment: 'AI enrichment...',
    finalizingDocument: 'Finalizing document...',
    generateRemediationPlan: 'Generate ANSSI E3R Remediation Plan',
    remediationPlanDesc: 'The remediation plan includes the 4 ANSSI phases with procedures, scripts and recommendations based on detected vulnerabilities.',
    selectAScan: '-- Select a scan --',
    noScansAvailable: '-- No scan available --',
    globalRemediation: 'Global remediation',
    scansWithVulns: 'Scans with vulnerabilities',
    scansWithoutVulns: 'Scans without vulnerabilities',
    noScansInWorkspace: 'No scans available in this workspace. Launch a security scan to generate a remediation plan.',
    continuityRecovery: 'Continuity & Activity Recovery',
    referenceScanOptional: 'Reference scan (optional — enriches the cyber section of PCRA)',
    noScanGenericPcra: '-- No scan (generic PCRA) --',
    generationOptions: 'Generation options',
    generatingPcra: 'Generating PCRA...',
    analyzingIsRisks: 'Analyzing IS and operational risks...',
    identifyingCriticalActivities: 'Identifying critical activities and DMIA...',
    generatingOperationalSheets: 'Generating operational sheets...',
    aiEnrichmentContinuity: 'AI enrichment of continuity solutions...',
    generatePcra: 'Generate PCRA — ANS Domain 2',
    pcraCompliantDesc: 'Compliant with ANS Healthcare PCRA Kit · July 3, 2025 decree · ISO 22301 · D2 evaluation criteria',
    adPentestMethodology: 'PASSI Active Directory Methodology',
    noAdPentestData: 'No AD pentest performed — paste your data manually below.',
    importFromExistingPentest: 'Import from an existing AD pentest',
    loadingPentests: 'Loading pentests...',
    aiAnalyzingData: 'AI is analyzing your PingCastle and ORADAD data...',
    reportsGeneratedSuccessfully: 'Reports generated successfully',
    generateAdReports: 'Generate Active Directory Reports',
    compliancePlans: 'Compliance Plans',
    generateDocument: 'Generate document',
    askQuestion: 'Ask a question about reports, vulnerabilities, recommendations...',
    reportsLibrary: 'Reports Library',
    refreshList: 'Refresh list',
    generatedReportsWillAppear: 'Generated reports will appear here',
    regenerateReport: 'Regenerate report',
    download: 'Download',
    configurationSummary: 'Configuration summary',
    selectedScansLabel: 'Selected scans',
    notSelected: 'Not selected',
    readyToGenerate: 'Ready to generate',
    selectScans: 'Select scans',
    chooseReportType: 'Choose a report type',
    recentReports: 'Recent reports',
    selectAtLeastOneScan: 'Select at least one scan',
    aiReportGeneration: 'AI Report Generation',
    generateWithAi: 'Generate a report with AI',
    aiDetectsConfig: 'Describe the desired report in natural language. AI will automatically detect the type, format and target scan.',
    configurationDetected: 'Configuration detected:',
    proFeature: 'Pro Feature',
    retry: 'Retry',
    // Export modal
    export: {
      title: 'Export',
      processing: 'Exporting...',
      generating: 'Generating file',
      takingLong: 'This operation is taking longer than expected.',
      canWaitOrEmail: 'You can wait, or close this window and we will send you a link by email.',
      sendByEmail: 'Send by email',
      continueWaiting: 'You can also continue waiting, the download will start automatically.',
      emailSent: 'Email sent!',
      emailSentDesc: 'You will receive the download link by email shortly.',
      wordLocked: 'Available for Enterprise plans and above'
    },
    // Report configuration placeholders
    placeholders: {
      footerText: 'E.g.: Confidential document - Do not distribute',
      logoUrl: 'https://company.com/logo.png',
      contactEmail: 'contact@example.com',
      sectionTitle: 'Section title...',
      sectionDescription: 'Description (optional)...',
      contentTemplate: 'Enter content template (Markdown supported)...\n\nAvailable variables:\n{{scan.target}} - Scan target\n{{scan.date}} - Scan date\n{{vulnerabilities.count}} - Vulnerabilities count\n{{vulnerabilities.critical}} - Critical vulnerabilities'
    },
    // Report configuration labels
    config: {
      title: 'Configuration',
      subtitle: 'Configure available report types and customize their content',
      settingsTitle: 'Report settings',
      brandingTitle: 'Report branding',
      defaultLanguage: 'Default language',
      confidentialityLevel: 'Confidentiality level',
      includeOptions: 'Include options',
      includeLogo: 'Include logo',
      includeTableOfContents: 'Include table of contents',
      includeAppendices: 'Include appendices',
      includeMethodology: 'Include methodology',
      footerTextLabel: 'Footer text',
      logoUrlLabel: 'Logo URL',
      primaryColor: 'Primary color',
      secondaryColor: 'Secondary color',
      companyInfo: 'Company information (for reports)',
      companyName: 'Company name',
      address: 'Address',
      contactEmail: 'Contact email',
      phone: 'Phone',
      website: 'Website',
      sectionsTitle: 'Report sections',
      addSection: 'Add section',
      noTypeSelected: 'No type selected',
      noTypeSelectedHint: 'Click on a report type in the list to view and customize its sections',
      sectionRequired: 'Required section',
      sectionActive: 'Active',
      requiredBadge: 'Required',
      contentTemplateLabel: 'Content template (Markdown supported)',
      clickToAddTemplate: 'Click to add a content template...',
      markdownHint: 'Use Markdown for formatting. Variables: {{variable}}',
      noReportTypes: 'No report types available'
    },
    // Error/status messages
    loadError: 'Error loading report',
    loadingReport: 'Loading report...',
    loadDataError: 'Error loading data',
    loadSectionsError: 'Error loading sections',
    deleteError: 'Error deleting',
    reorderError: 'Error reordering',
    addError: 'Error adding',
    updateError: 'Error updating',
    saveError: 'Error saving',
    downloadError: 'Error downloading',
    generateError: 'Error generating report',
    regenerateError: 'Error regenerating report',
    noGeneratedFile: 'No file generated',
    noScansAvailable: 'No completed scans available to generate reports. Please run a scan first.',
    noVulnsDetected: 'No vulnerabilities detected in scans. The remediation plan will be empty.',
    loadingPentests: 'Loading pentests...',
    noScanAvailable: '-- No scan available --',
    networkError: 'Network error. Check your connection.',
    pageCountLabels: {
      executive: 'Summary',
      technical: 'Full',
      vulnerability_list: 'List',
      redteam: 'Narrative',
      retest: 'Comparative',
      multi_campaign: 'Multi-scan',
      active_directory: 'AD Audit',
      data_leak: 'DLP',
      attack_surface: 'ASM'
    },
    aiPrompts: {
      executiveSummary: 'Executive summary',
      executiveSummaryQuery: 'Generate an executive summary of vulnerabilities found for management',
      recommendations: 'Recommendations',
      recommendationsQuery: 'What are the priority remediation recommendations?',
      trends: 'Trends',
      trendsQuery: 'Analyze security trends from completed scans',
      criticalRisks: 'Critical risks',
      criticalRisksQuery: 'What are the critical risks to address immediately?'
    },
    pcraDomains: {
      heading: '4 unavailability scenarios covered',
      informationSystems: 'Information Systems',
      staffKeySkills: 'Staff / Key Skills',
      buildingsInfra: 'Buildings / Infrastructure',
      suppliers: 'Suppliers / Subcontractors'
    },
    pcraPhases: {
      heading: '4 build phases',
      scoping: 'Scoping',
      scopingSub: 'Perimeter & governance',
      bia: 'BIA Analysis',
      biaSub: 'Critical activities & DMIA',
      development: 'Development',
      developmentSub: 'Continuity solutions',
      mco: 'MCO',
      mcoSub: 'Operational maintenance',
      phaseLabel: 'Phase'
    },
    adReportTypes: {
      comex: 'COMEX Report',
      comexDesc: '10–15 pages',
      technical: 'Technical Report',
      technicalDesc: '25–60 pages, AD-XX',
      actionPlan: 'Action plan',
      actionPlanDesc: 'Excel 16 columns',
      aiSummary: 'AI Summary',
      aiSummaryDesc: 'Roadmap 30/90/180d'
    },
    adForm: {
      missionName: 'Mission name',
      missionPlaceholder: 'e.g. AD Audit — Prod Infra',
      clientName: 'Client / organization name',
      clientPlaceholder: 'e.g. ACME Corp',
      pingcastleResults: 'PingCastle results (paste here)',
      pingcastlePlaceholder: 'Paste PingCastle results here:\n- Global score, rules triggered\n- Stale Objects, Privileged Accounts\n- Trusts, Password policies, Delegations\n\nAccepts: plain text, HTML, CSV…',
      oradadResults: 'ORADAD results (paste here)',
      oradadPlaceholder: 'Paste ORADAD results here:\n- Structural anomalies\n- Delegations, critical groups\n- Sensitive accounts, GPO, obsolete objects\n- Dangerous ACLs, exposed SPNs…',
      charactersSuffix: 'characters',
      optionalEnrich: 'Optional — enriches AI analysis',
      reportsToGenerate: 'Reports to generate',
      comexPdfLabel: 'COMEX Report (PDF)',
      comexPdfDesc: '10-15 pages, COMEX/CISO',
      technicalPdfLabel: 'Technical Report (PDF)',
      technicalPdfDesc: '25-60 pages, AD-XX findings',
      actionPlanLabel: 'Action plan (Excel)',
      actionPlanDesc: '16 columns, P1/P2/P3'
    },
    outputFormat: 'Output format'
  },

  // Account
  account: {
    title: 'My Account',
    profile: 'Profile',
    security: 'Security',
    subscription: 'Subscription',
    billing: 'Billing',
    credits: 'Credits',
    notifications: 'Notifications',
    integrations: 'Integrations',
    referral: 'Referral',
    activity: 'Activity',
    contracts: 'Contracts',

    // Profile section
    profileSection: {
      title: 'Profile Information',
      avatar: 'Profile picture',
      changeAvatar: 'Change picture',
      removeAvatar: 'Remove picture',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      position: 'Position',
      timezone: 'Timezone',
      language: 'Portal language',
      languageDescription: 'Choose the display language for the interface',
      updateSuccess: 'Profile updated successfully',
      updateError: 'Error updating profile',
      // Language names in English
      languages: {
        fr: 'French',
        en: 'English',
        es: 'Spanish',
        de: 'German',
        it: 'Italian',
        pt: 'Portuguese'
      }
    },

    // Security section
    securitySection: {
      title: 'Account Security',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      passwordRequirements: 'Password must be at least 8 characters',
      twoFactorAuth: 'Two-factor authentication',
      enable2FA: 'Enable 2FA',
      disable2FA: 'Disable 2FA',
      twoFactorEnabled: '2FA enabled',
      twoFactorDisabled: '2FA disabled',
      activeSessions: 'Active sessions',
      revokeSession: 'Revoke session',
      revokeAllSessions: 'Revoke all sessions',
      loginHistory: 'Login history',
      lastLogin: 'Last login',
      apiKeys: 'API Keys',
      generateApiKey: 'Generate API key',
      deleteApiKey: 'Delete API key',
      passwordsNoMatch: 'Passwords do not match',
      passwordChanged: 'Password changed',
      mfaConfigError: 'MFA configuration error',
      invalidCode: 'Invalid code',
      apiKeyGenerated: 'API key generated and copied',
      confirmApiKeyGenerate: 'Generate a new API key? The old one will be invalidated.',
      enterMfaCode: 'Enter your MFA code to disable',
      passwordCopied: 'Password copied to clipboard',
      generatePasswordFirst: 'Generate a password and verify your phone number',
      smsSent: 'Password sent by SMS',
      smsError: 'Error sending SMS',
      mfaEnabled: '2FA enabled',
      mfaDisabled: '2FA disabled',
      passwordApplied: 'Password applied to fields',
    },

    // Subscription section
    subscriptionSection: {
      title: 'Subscription',
      currentPlan: 'Current plan',
      planDetails: 'Plan details',
      features: 'Included features',
      usage: 'Usage',
      limits: 'Limits',
      renewalDate: 'Renewal date',
      cancelSubscription: 'Cancel subscription',
      upgradePlan: 'Upgrade plan',
      downgradePlan: 'Downgrade plan',
      plans: {
        free: 'Free',
        pro: 'Pro',
        enterprise: 'Enterprise',
        dedicated: 'Dedicated'
      }
    },

    // Credits section
    creditsSection: {
      title: 'Credits Management',
      subtitle: 'Manage your credits, subscriptions and packs',
      balance: 'Balance',
      totalCredits: 'Total credits',
      monthlyCredits: 'Monthly credits',
      packCredits: 'Pack credits',
      usedThisMonth: 'Used this month',
      remaining: 'Remaining',
      buyCredits: 'Buy credits',
      creditHistory: 'Credit history',
      transaction: 'Transaction',
      amount: 'Amount',
      creditCosts: 'Operation costs',
      scanCost: 'Scan cost',
      reportCost: 'Report cost',
      // Additional keys for CreditsPage
      expires: 'Expires on',
      noExpiration: 'No expiration',
      currentPlan: 'Current plan',
      statusActive: 'Active',
      monthlyPlans: 'Monthly plans',
      free: 'Free',
      perMonth: '/month',
      creditsPerMonth: 'credits/month',
      unlimitedWorkspaces: 'Unlimited client workspaces',
      externalScans: 'External scans',
      internalScans: 'Internal scans',
      adScans: 'Active Directory scans',
      select: 'Select',
      creditPacks: 'Credit packs',
      credits: 'credits',
      validity: 'Validity',
      months: 'months',
      buy: 'Buy',
      scans: 'Scans',
      leakDetection: 'Leak detection',
      audits: 'Audits',
      reports: 'Reports',
      noTransactions: 'No transactions',
      transactionHistory: 'Transaction history',
      refresh: 'Refresh',
      date: 'Date',
      type: 'Type',
      dashboard: 'Dashboard',
      plansAndPacks: 'Plans & Packs',
      history: 'History',
      errorOccurred: 'An error occurred',
      creditsAvailable: 'credits available',
      confirmPlanChange: 'Confirm plan change',
      confirmPurchase: 'Confirm purchase',
      planActiveImmediately: 'The plan will be active immediately',
      creditsAddedImmediately: 'Credits will be added immediately',
      cancel: 'Cancel',
      processing: 'Processing...',
      confirm: 'Confirm',
      planSubscribed: '{plan} plan subscription successful',
      packPurchased: '{pack} pack purchase successful',
      statusPremium: 'PREMIUM',
      statusExhausted: 'EXHAUSTED',
      statusCritical: 'CRITICAL',
      statusLow: 'LOW',
      unlimited: 'Unlimited',
      totalBalance: 'Total available balance',
      monthly: 'Monthly',
      packs: 'Packs'
    },

    // Notifications section
    notificationsSection: {
      title: 'Notification Preferences',
      emailNotifications: 'Email notifications',
      pushNotifications: 'Push notifications',
      scanCompleted: 'Scan completed',
      scanFailed: 'Scan failed',
      newVulnerability: 'New critical vulnerability',
      reportReady: 'Report ready',
      securityAlerts: 'Security alerts',
      weeklyDigest: 'Weekly digest',
      marketingEmails: 'Marketing emails'
    },

    // Integrations section
    integrationsSection: {
      title: 'Integrations',
      connected: 'Connected',
      notConnected: 'Not connected',
      configure: 'Configure',
      disconnect: 'Disconnect',
      testConnection: 'Test connection',
      connectionSuccess: 'Connection successful',
      connectionFailed: 'Connection failed',
      availableIntegrations: 'Available integrations',
      myIntegrations: 'My integrations'
    },

    // Referral section
    referralSection: {
      title: 'Referral Program',
      referralLink: 'Referral link',
      copyLink: 'Copy link',
      shareLink: 'Share link',
      inviteFriends: 'Invite friends',
      referralStats: 'Referral statistics',
      totalReferrals: 'Total referrals',
      pendingReferrals: 'Pending referrals',
      completedReferrals: 'Completed referrals',
      earnedCredits: 'Earned credits',
      inviteByEmail: 'Invite by email',
      contacts: 'Invited contacts',
      rewards: 'Rewards',
      leaderboard: 'Leaderboard',
      inviteContact: 'Invite a contact',
      shareDescription: 'Share this link to invite new users',
      loading: 'Loading...',
      yourLevel: 'Your level',
      nextLevel: 'Next level',
      creditsEarned: 'Credits earned',
      conversionFunnel: 'Conversion funnel',
      invited: 'Invited',
      clicked: 'Clicked',
      signedUp: 'Signed up',
      converted: 'Converted',
      clickRate: 'Click rate',
      conversionRate: 'Conversion rate',
      perClick: 'Per click',
      perSignup: 'Per signup',
      perProConversion: 'Per Pro conversion',
      noContacts: 'No contacts invited yet',
      inviteFirstContact: 'Invite your first contact',
      contact: 'Contact',
      creditsGenerated: 'Credits generated',
      topReferrers: 'Top Referrers',
      rank: 'Rank',
      user: 'User',
      tier: 'Tier',
      referrals: 'Referrals',
      conversions: 'Conversions',
      value: 'Value',
      you: '(you)',
      firstName: 'First name',
      lastName: 'Last name',
      company: 'Company',
      sendInvitation: 'Send invitation',
      referralLinkCopied: 'Referral link copied!',
      invitationSent: 'Invitation sent successfully!',
      contactRemoved: 'Contact removed',
      deleteContactConfirm: 'Delete this contact?',
      resendInvitation: 'Resend invitation',
      statusInvited: 'Invited',
      statusClicked: 'Clicked',
      statusSignedUp: 'Signed up',
      statusConverted: 'Converted',
      statusChurned: 'Churned',
      remainingToNextTier: 'remaining',
      errorSending: 'Error sending invitation',
      errorResending: 'Error resending invitation',
      errorDeleting: 'Error deleting contact',
      planSubscribed: '{plan} plan subscription successful',
      packPurchased: '{pack} pack purchase successful'
    },

    // Save buttons
    // Avatar section
    avatarSection: {
      invalidType: 'Please select an image',
      tooLarge: 'Image must not exceed 2 MB',
      updateSuccess: 'Avatar updated',
      updateError: 'Error updating avatar',
      readError: 'File read error'
    },

    // Company section
    companySection: {
      title: 'Company information',
      logo: 'Company logo',
      name: 'Company name',
      legalForm: 'Legal form',
      capital: 'Share capital',
      address: 'Address',
      city: 'City',
      postalCode: 'Postal code',
      country: 'Country',
      timezone: 'Timezone (for scans)',
      legalRep: 'Legal representative',
      fullName: 'Full name',
      updateSuccess: 'Company information updated successfully',
      updateError: 'Save error'
    },

    // Team section
    teamSection: {
      confirmRemove: 'Are you sure you want to remove this member?',
      memberRemoved: 'Member removed'
    },

    // Logo section
    logoSection: {
      updated: 'Logo updated',
      updatedAV: 'Logo updated - Antivirus scan OK',
      updateError: 'Error updating logo',
      deleted: 'Logo deleted',
      deleteError: 'Error deleting logo'
    },

    configuration: 'Configuration',
    team: 'Team',
    users: 'Users',
    help: 'Help',
    history: 'History',
    version: 'Version',
    support: 'Support',
    reportTypes: 'Report types',
    loadError: 'Error loading account',
    saveAll: 'Save all',
    saveProfile: 'Save profile',
    saveCompany: 'Save company'
  },

  // Settings
  settings: {
    title: 'Settings',
    general: 'General',
    tools: 'Tools',
    network: 'Network',
    advanced: 'Advanced',

    // General settings
    generalSection: {
      title: 'General Settings',
      defaultScanType: 'Default scan type',
      defaultReportFormat: 'Default report format',
      autoSaveReports: 'Auto-save reports',
      enableNotifications: 'Enable notifications',
      darkMode: 'Dark mode',
      compactView: 'Compact view'
    },

    // Tools settings
    toolsSection: {
      title: 'Tools Configuration',
      enabledTools: 'Enabled tools',
      toolSettings: 'Tool settings',
      timeout: 'Timeout',
      threads: 'Thread count',
      verbosity: 'Verbosity level'
    },

    // Network settings
    networkSection: {
      title: 'Network Configuration',
      proxySettings: 'Proxy settings',
      vpnSettings: 'VPN settings',
      dnsSettings: 'DNS settings',
      useProxy: 'Use proxy',
      proxyHost: 'Proxy host',
      proxyPort: 'Proxy port'
    },

    // Server status
    uptime: 'Uptime'
  },

  // Admin
  admin: {
    title: 'Administration',
    users: 'Users',
    companies: 'Companies',
    system: 'System',
    logs: 'Logs',
    maintenance: 'Maintenance',

    // Users management
    usersSection: {
      title: 'User Management',
      addUser: 'Add user',
      editUser: 'Edit user',
      deleteUser: 'Delete user',
      activateUser: 'Activate user',
      deactivateUser: 'Deactivate user',
      resetPassword: 'Reset password',
      role: 'Role',
      roles: {
        admin: 'Administrator',
        user: 'User',
        viewer: 'Viewer'
      },
      lastLogin: 'Last login',
      createdAt: 'Created at',
      noUsers: 'No users'
    },

    // System
    systemSection: {
      title: 'System',
      systemInfo: 'System information',
      version: 'Version',
      uptime: 'Uptime',
      restart: 'Restart',
      backup: 'Backup',
      restore: 'Restore',
      update: 'Update'
    },
    columns: {
      company: 'Company',
      plan: 'Plan',
      status: 'Status',
      users: 'Users',
      scans: 'Scans',
      createdOn: 'Created on',
      actions: 'Actions',
      user: 'User',
      role: 'Role',
      emailVerified: 'Email verified',
      mfa: 'MFA',
      lastLogin: 'Last login',
      timestamp: 'Timestamp',
      action: 'Action',
      resourceType: 'Resource type',
      ipAddress: 'IP Address',
      statusCol: 'Status',
    },
    actions: {
      resendVerification: 'Resend verification email',
      sendPasswordReset: 'Send password reset link',
      changePassword: 'Change password',
      resendInvitation: 'Resend invitation',
      unlockAccount: 'Unlock account',
      forceEmailVerification: 'Force email verification',
      activateAccount: 'Activate account',
      deactivateAccount: 'Deactivate account',
      disableMfa: 'Disable MFA',
    },
    // Stats cards
    revenueMonth: 'Revenue (month)',
    revenueSubtitle: 'Subscriptions and credits',
    // Tabs
    auditLogs: 'Audit Logs',
    suspiciousActivity: 'Suspicious Activity',
    // Pagination
    pagination: {
      of: 'of',
      rowsPerPage: 'Rows per page',
    },
    // Legend
    legend: 'Legend',
    statusCompleted: 'Completed',
    statusArchived: 'Archived',
    // Status chips
    locked: 'Locked',
    statusSuccess: 'Success',
    statusFailed: 'Failed',
    // Table columns
    owner: 'Owner',
    // Tooltips company status
    companyTooltip: {
      active: 'Active company with full access',
      suspended: 'Suspended company, access blocked',
      pending: 'Awaiting approval or payment',
      inactive: 'Inactive company, account closed',
    },
    // Tooltips workspace status
    statusTooltip: {
      active: 'Workspace currently in use',
      completed: 'All tasks completed',
      archived: 'Archived workspace, read-only access',
      pending: 'Awaiting configuration or validation',
      inactive: 'Inactive workspace',
    },
    // Dialog labels
    companyDetails: 'Company Details',
    subscription: 'Subscription',
    noSubscription: 'No subscription',
    userDetails: 'User Details',
    fullName: 'Full name',
    accountStatus: 'Account status',
    adminApproval: 'Admin approval',
    approved: 'Approved',
    security: 'Security',
    failedAttempts: 'Failed attempts',
    lockedUntil: 'Locked until',
    blocked: 'Blocked',
    loginSection: 'Login',
    never: 'Never',
    lastIp: 'Last IP',
    creationDate: 'Creation date',
    setNewPasswordFor: 'Set a new password for',
    createNewUser: 'Create new user',
    sendInvitationEmail: 'Send invitation email',
    newUser: 'New user',
    exportCsv: 'Export as CSV',
    // Suspicious activity
    suspiciousActivityDesc: 'This section displays failed login attempts and suspicious activities.',
    seeConsole: 'See console',
    loadAlerts: 'Load alerts',
    // Misc
    vsLastMonth: 'vs last month',
  },

  // Errors
  errors: {
    generic: 'An error occurred',
    notFound: 'Page not found',
    unauthorized: 'Unauthorized access',
    forbidden: 'Access forbidden',
    serverError: 'Server error',
    networkError: 'Network error',
    timeout: 'Request timeout',
    validation: 'Validation error',
    invalidEmail: 'Invalid email',
    invalidPassword: 'Invalid password',
    passwordMismatch: 'Passwords do not match',
    requiredField: 'This field is required',
    minLength: 'Minimum {min} characters required',
    maxLength: 'Maximum {max} characters allowed',
    fillAllFields: 'Please fill in all required fields',
    verificationFailed: 'Email verification failed. The link may be expired or invalid.',
    invalidVerificationLink: 'This verification link is invalid or has expired. Please request a new link.',
    rateLimitExceeded: 'Too many attempts. Please try again in a few minutes.',
    emailAlreadyUsed: 'This email is already in use',
    companyAlreadyRegistered: 'This company is already registered',
    registrationError: 'Error during registration',
    genericError: 'An unexpected error occurred',
    rateLimitEmail: 'Please wait a few minutes before resending a verification email.',
    disposableEmailNotAllowed: 'Disposable emails are not allowed',
    personalEmailNotAllowed: 'The email {domain} is not allowed. Use a professional email.',
    invalidResetLink: 'This reset link is invalid or has expired. Please request a new link.',
    resetLinkExpired: 'This reset link has expired. Please request a new link.',
    resetPasswordFailed: 'Password reset failed. Please try again.',
    passwordCriteriaNotMet: 'Password does not meet all required criteria.',
    // Error page
    401: {
      title: 'Unauthorized',
      subtitle: 'Oops! You need to log in',
      description: 'Your session has expired or you are not authenticated. Please log in to access this page.',
      redirectText: 'Redirecting to login'
    },
    403: {
      title: 'Access Denied',
      subtitle: 'Oops! Access forbidden',
      description: 'You do not have the necessary permissions to access this resource.',
      redirectText: 'Redirecting to dashboard'
    },
    404: {
      title: 'Page Not Found',
      subtitle: 'Oops! Page not found',
      description: 'The page you are looking for does not exist or has been moved.',
      redirectText: 'Redirecting to dashboard'
    },
    500: {
      title: 'Server Error',
      subtitle: 'Oops! An error occurred',
      description: 'The server encountered an error. Please try again in a few moments.',
      redirectText: 'Redirecting to dashboard'
    },
    503: {
      title: 'Service Unavailable',
      subtitle: 'Oops! Service temporarily unavailable',
      description: 'The service is temporarily unavailable for maintenance. Please try again in a few moments.',
      redirectText: 'Redirecting to dashboard'
    },
    backendMessages: {
      'Workspace not found': 'Workspace not found',
      'Invalid signature token': 'Invalid signature token',
      'Contract already signed': 'Contract already signed',
      'Contract already pending signature. Cancel existing request first.': 'Contract already pending signature. Cancel existing request first.',
      'Contract not yet signed': 'Contract not yet signed',
      'Signed contract file not found': 'Signed contract file not found',
      'Contract file not found on disk': 'Contract file not found on disk',
      'Contract already signed, cannot cancel': 'Contract already signed, cannot cancel',
      'No pending signature request to cancel': 'No pending signature request to cancel',
      'User not found': 'User not found',
      'Invalid credentials': 'Invalid credentials',
      'Access denied': 'Access denied',
      'Permission denied': 'Permission denied',
      'Not found': 'Not found',
      'Bad request': 'Bad request',
      'Internal server error': 'Internal server error',
      'Service unavailable': 'Service unavailable'
    },
    backToDashboard: 'Back to Dashboard',
    retry: 'Retry',
    supportContact: 'If the problem persists, contact technical support.',
    redirectingIn: 'in',
    seconds: 'seconds',
    error: 'Error',
    companyRequired: 'You must belong to a company to perform this action',
    selectRequired: 'Please make a selection',
    sessionExpired: 'Session expired. Please log in again.'
  },

  // Success messages
  success: {
    saved: 'Saved successfully',
    deleted: 'Deleted successfully',
    updated: 'Updated successfully',
    created: 'Created successfully',
    copied: 'Copied to clipboard',
    sent: 'Sent successfully',
    uploaded: 'Uploaded successfully'
  },

  // Time
  time: {
    now: 'Now',
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years',
    ago: 'ago',
    in: 'in'
  },

  // Credentials
  credentials: {
    title: 'Credentials',
    username: 'Username',
    password: 'Password',
    hash: 'Hash',
    domain: 'Domain',
    source: 'Source',
    foundAt: 'Found at',
    noCredentials: 'No credentials found',
    export: 'Export credentials',
    addNumbers: 'Add numbers',
    addSpecialChars: 'Special characters',
    noPasswordSave: 'No password to save',
    saveDictionaryError: 'Error saving dictionary',
    loadDictionariesError: 'Error loading dictionaries',
    loadDictionaryError: 'Error loading dictionary',
    deleteError: 'Error deleting',
    downloadError: 'Error downloading',
    searchError: 'Search failed',
    validationError: 'Error during validation',
    noCredentialExport: 'No credentials to export',
    noPasswordExport: 'No passwords to export',
    decryptError: 'Decryption error',
    noDictionarySaved: 'No dictionary saved',
    noWorkspace: '-- No workspace --',
    noResult: 'No result',
    noResultMatch: 'No credential matches',
    noPasswordAvailable: 'No password available'
  },

  // Sessions
  sessions: {
    title: 'Sessions',
    pageTitle: 'Exploitation Sessions',
    pageDescription: 'Management of exploitation sessions and compromised access',
    sessionDetails: 'Session details',
    activeSession: 'Active session',
    closedSession: 'Closed session',
    sessionType: 'Session type',
    target: 'Target',
    startedAt: 'Started at',
    endedAt: 'Ended at',
    duration: 'Duration',
    commands: 'Commands',
    noSessions: 'No sessions',
    closeSession: 'Close session',
    interactiveShell: 'Interactive Shell',
    quickActions: 'Quick Actions',
    quickCommands: 'Quick Commands',
    defaultSessionType: 'Shell',
    sessionLabel: 'Session',
    manualExploit: 'Manual',
    platform: 'Platform',
    platformUnknown: 'Unknown',
    exploitUsed: 'Exploit used',
    commandsExecuted: 'Commands executed',
    status: {
      active: 'Active',
      inactive: 'Inactive',
      closed: 'Closed',
      stale: 'Stale',
      idle: 'Idle',
      error: 'Error',
      unknown: 'Unknown',
      queued: 'Queued',
      running: 'Running',
      pending: 'Pending',
      completed: 'Completed',
      failed: 'Failed'
    },
    badges: {
      root: 'ROOT',
      persistent: 'PERSISTENT'
    },
    persistence: {
      installed: 'Installed',
      notInstalled: 'Not installed'
    },
    quickPrompts: {
      help: 'Help',
      privesc: 'Privesc',
      persistence: 'Persistence',
      lateral: 'Lateral movement',
      pocAuto: 'Auto PoC',
      aptModules: 'APT modules'
    },
    errors: {
      connectionError: 'Server connection error',
      loadingError: 'Error loading sessions',
      actionError: 'Error executing action',
      serverError: 'Internal server error',
      serviceUnavailable: 'Service temporarily unavailable',
      loadFailed: 'Loading failed',
      screenshotFailed: 'Screenshot failed',
      privescFailed: 'Privilege escalation failed',
      persistenceFailed: 'Persistence installation failed',
      aptExecutionFailed: 'APT module execution failed'
    },
    actions: {
      screenshotSuccess: 'Screenshot captured',
      privescSuccess: 'Privilege escalation successful',
      privescCompleted: 'Privilege escalation attempt completed',
      persistenceSuccess: 'Persistence mechanism installed',
      persistenceCompleted: 'Installation completed'
    },
    privilegeLevel: 'Privilege level',
    lastActivity: 'Last activity',
    screenshot: 'Screenshot',
    privilegeEscalation: 'Privilege escalation',
    downloadLogs: 'Download Logs',
    migrationRecommended: 'Recommended migration',
    connected: 'Connected',
    connecting: 'Connecting...',
    confirmInstallPersistence: 'Install a persistence mechanism?',
    confirmCloseSession: 'Are you sure you want to close this session?'
  },

  // Support
  support: {
    title: 'Support',
    myTickets: 'My Support Tickets',
    manageRequests: 'Manage your assistance requests',
    newTicket: 'New ticket',
    ticketDetails: 'Ticket details',
    subject: 'Subject',
    message: 'Message',
    priority: 'Priority',
    status: 'Status',
    category: 'Category',
    created: 'Created',
    createdOn: 'Created on',
    updated: 'Last updated',
    resolved: 'Resolved',
    resolvedOn: 'Resolved on',
    noTickets: 'No tickets',
    noTicketsFound: 'No tickets found',
    noTicketsYet: 'You haven\'t created any support tickets yet',
    tryModifyingSearch: 'Try modifying your search criteria',
    createFirstTicket: 'Create my first ticket',
    sendMessage: 'Send message',
    send: 'Send',
    sending: 'Sending...',
    closeTicket: 'Close ticket',
    closing: 'Closing...',
    ticketClosed: 'This ticket is closed. For a new request, create a new ticket.',
    search: 'Search for a ticket...',
    allStatuses: 'All statuses',
    refresh: 'Refresh',
    backToTickets: 'Back to tickets',
    ticketNumber: 'Number',
    you: 'You',
    supportTeam: 'SYLink Support',
    system: 'System',
    writeReply: 'Write your reply...',
    detailedDescription: 'Detailed description',
    informations: 'Information',
    needHelp: 'Need help?',
    responseTime: 'Estimated response time',
    responseTimeDesc: 'Our team usually responds within 24 business hours. Urgent tickets are processed with priority. You will receive an email notification as soon as a response is provided.',
    supportResponseDesc: 'Our support team usually responds within 24 business hours. For emergencies, please indicate high priority.',
    newTicketTitle: 'New Ticket',
    newTicketDesc: 'Describe your problem and our team will respond quickly',
    describeIssue: 'Briefly describe your problem...',
    relatedWorkspace: 'Related Client / Workspace (optional)',
    noSpecificWorkspace: 'No specific workspace',
    detailedDescPlaceholder: 'Describe your problem in detail. The more information you provide, the faster we can help you...\n\n- What are you trying to do?\n- What is happening?\n- What did you expect?\n- Do you have an error message?',
    charactersCount: '{count} characters',
    charactersMin: '{count} characters (minimum {min})',
    cancel: 'Cancel',
    createTicket: 'Create ticket',
    creating: 'Creating...',
    rateSupport: 'How would you rate the quality of our support?',
    comment: 'Comment (optional)...',
    confirm: 'Confirm',
    messages: 'message',
    messagesPlural: 'messages',
    resolutionNotes: 'Resolution notes',
    yourRating: 'Your rating',

    // Statuses
    statuses: {
      open: 'Open',
      in_progress: 'In Progress',
      waiting_customer: 'Waiting for your response',
      waiting_internal: 'In processing',
      resolved: 'Resolved',
      closed: 'Closed'
    },

    // Priorities
    priorities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      urgent: 'Urgent',
      lowDesc: 'Not urgent, can wait',
      mediumDesc: 'Normal importance',
      highDesc: 'Requires quick attention',
      urgentDesc: 'Critical impact on activity',
      priority: 'Priority'
    },

    // Categories
    categories: {
      technical: 'Technical',
      billing: 'Billing',
      feature_request: 'Feature Request',
      bug_report: 'Bug Report',
      account: 'Account',
      security: 'Security',
      other: 'Other',
      technicalDesc: 'Technical problems, errors, malfunctions',
      billingDesc: 'Questions about invoices, payments, subscriptions',
      feature_requestDesc: 'Improvement suggestions or new features',
      bug_reportDesc: 'Report a bug or unexpected behavior',
      accountDesc: 'Account management, access, permissions',
      securityDesc: 'Security questions or concerns',
      otherDesc: 'Other type of request'
    },

    // Errors
    errors: {
      loadingTickets: 'Error loading tickets',
      loadingTicket: 'Error loading ticket',
      sendingMessage: 'Error sending message',
      closingTicket: 'Error closing ticket',
      creatingTicket: 'Error creating ticket',
      ticketNotFound: 'Ticket not found',
      retry: 'Retry',
      fixFormErrors: 'Please correct the errors in the form',
      subjectRequired: 'Subject is required',
      subjectMinLength: 'Subject must contain at least 5 characters',
      descriptionRequired: 'Description is required',
      descriptionMinLength: 'Description must contain at least 20 characters'
    },

    // Success messages
    success: {
      ticketCreated: 'Ticket {number} created successfully',
      messageSent: 'Message sent',
      ticketClosed: 'Ticket closed successfully'
    }
  },

  // Attack
  attack: {
    title: 'Attack Center',
    description: 'Advanced attack tools and dynamic orchestrator',
    selectTarget: 'Select target',
    selectTechnique: 'Select technique',
    launchAttack: 'Launch attack',
    attackInProgress: 'Attack in progress',
    attackCompleted: 'Attack completed',
    attackFailed: 'Attack failed',
    techniques: 'Techniques',
    payloads: 'Payloads',
    results: 'Results',
    dynamicOrchestrator: 'Dynamic Orchestrator',
    attackGraph: 'Attack Graph',
    attackBuilder: 'Attack Builder',
    launchChain: 'Launch chain',
    continueChain: 'Resume',
    restartAll: 'Restart all',
    executing: 'Executing...',
    aiSuggestions: 'AI Suggestions',
    ready: 'Ready',
    inProgress: 'In progress...'
  },

  // Pricing
  pricing: {
    title: 'Choose your plan',
    subtitle: 'Security solutions adapted to all business sizes. Start for free and scale according to your needs.',
    monthly: 'Monthly',
    yearly: 'Yearly',
    yearlyDiscount: '-17%',
    perMonth: 'month',
    perYear: 'year',
    ht: 'excl. VAT',
    or: 'Or',
    perMonthShort: '/mo',
    onQuote: 'On quote',
    free: 'Free',
    // Plan names and descriptions
    plans: {
      gratuit: {
        name: 'Free',
        subtitle: 'Discovery',
        description: 'Ideal for testing the platform',
        cta: 'Start for free'
      },
      pro: {
        name: 'Pro',
        subtitle: 'Most popular',
        description: 'For professionals and SMBs',
        cta: 'Choose Pro',
        badge: 'Recommended'
      },
      entreprise: {
        name: 'Enterprise',
        subtitle: 'For large teams',
        description: 'Advanced features and dedicated support',
        cta: 'Choose Enterprise'
      },
      entreprise_plus: {
        name: 'Group',
        subtitle: 'For large organizations',
        description: 'Extended volume and premium support',
        cta: 'Choose Group'
      },
      sur_mesure: {
        name: 'Custom',
        subtitle: 'Customized solution',
        description: 'Adapted to your specific needs',
        cta: 'Contact us'
      }
    },
    // Features
    features: {
      simulationOnly: 'Simulation mode only',
      oneUser: '1 user',
      oneTarget: '1 test target',
      basicDashboard: 'Basic dashboard',
      realScans: 'Real scans',
      pdfReports: 'PDF reports',
      technicalSupport: 'Technical support',
      apiAccess: 'API Access',
      unlimitedScans: 'Unlimited AI scans',
      fiveUsers: '5 users',
      tenTargets: '10 targets',
      customPdfReports: 'Custom PDF reports',
      credentialSearch: 'Credential search',
      autoScheduling: 'Auto scheduling',
      prioritySupport: 'Priority support',
      allProFeatures: 'All Pro features +',
      fifteenUsers: '15 users',
      thirtyTargets: '30 targets',
      ssoSaml: 'SSO / SAML',
      complianceAudit: 'Compliance audit',
      slaGuarantee: '99.9% SLA guarantee',
      dedicatedSupport: 'Dedicated support',
      teamTraining: 'Team training included',
      allEnterpriseFeatures: 'All Enterprise features +',
      unlimitedUsers: 'Unlimited users',
      fiftyTargets: '50 targets',
      advancedWorkspaces: 'Advanced multi-workspaces',
      whiteLabelReports: 'White-label reports',
      support24_7: '24/7 dedicated support',
      accountManager: 'Dedicated account manager',
      customOnboarding: 'Custom onboarding',
      allGroupFeatures: 'All Group features +',
      allGroupeFeatures: 'All Group plan +',
      dedicatedInfra: 'Dedicated infrastructure',
      customIntegrations: 'Custom integrations',
      specificDevelopment: 'Specific developments',
      sourceCodeAudit: 'Source code audit',
      manualPentest: 'Manual penetration tests',
      cissoSupport: 'CISO support',
      customContract: 'Custom contract'
    },
    // Sections
    whyChoose: 'Why choose SYLink Pentest?',
    aiTitle: 'Artificial Intelligence',
    aiDesc: 'Our AI analyzes and exploits vulnerabilities autonomously, simulating the behavior of an expert pentester.',
    securityTitle: 'Maximum Security',
    securityDesc: 'Your data is encrypted and secure. No sensitive information is stored after tests.',
    reportsTitle: 'Detailed Reports',
    reportsDesc: 'Generate professional PDF reports with remediation recommendations and CVSS scoring.',
    // FAQ
    faqTitle: 'Frequently asked questions',
    faqCanChangePlan: 'Can I change my plan?',
    faqCanChangePlanAnswer: 'Yes, you can upgrade or downgrade your plan at any time. Changes are effective immediately and prorated.',
    faqFreePlan: 'How does the free plan work?',
    faqFreePlanAnswer: 'The free plan allows you to test the platform in simulation mode. No real scans are performed but you discover all the features.',
    faqCommitment: 'Is there a commitment?',
    faqCommitmentAnswer: 'No commitment. You can cancel at any time. Annual billing offers 2 months free.',
    faqSupport: 'What support is included?',
    faqSupportAnswer: 'The Pro plan includes priority email support. The Enterprise plan benefits from 24/7 dedicated support.',
    // Contact CTA
    needHelpChoosing: 'Need help choosing?',
    needHelpDesc: 'Our team is available to advise you and answer all your questions. Get a personalized platform demonstration.',
    needHelpDescShort: 'Our team is available to support you and answer all your questions.',
    contactUs: 'Contact us',
    requestCall: 'Request a call',
    // Banners
    welcomeTitle: 'Welcome to SYLink Pentest!',
    welcomeDesc: 'Your account is activated. Choose the plan that suits your needs.',
    welcomeDescShort: 'Choose the plan that fits your needs',
    paymentError: 'Payment error',
    close: 'Close',
    redirecting: 'Redirecting...',
    securedByStripe: 'Secure payment by Stripe',
    // UI labels
    detailedComparison: 'Detailed comparison',
    infrastructureOptions: 'Infrastructure options',
    infrastructureDesc: 'Choose the deployment mode that fits your needs and constraints',
    choosePlan: 'Choose your',
    choosePlanHighlight: 'plan',
    pageSubtitle: 'Automate your penetration tests with AI. From freelance to enterprise, we have the plan you need.',
    contactBanner: 'All our plans are customized to your needs',
    foreverFree: 'Forever',
    customPricing: 'On quote',
    customPricingLabel: 'Custom pricing',
    perMonthHT: '/mo excl. VAT',
    billedPerYear: 'Billed',
    billedPerYearSuffix: '/year',
    requestQuote: 'Request a quote',
    startFree: 'Start for free',
    learnMoreDedicated: 'Learn more about dedicated servers',
    readOnlyApi: 'Read-only',
    featureRow: 'Feature',
    priceRow: 'Price'
  },

  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'AD attack tools with AI LLM assistance and automated PoC',
    domain: 'Domain',
    dcIp: 'Domain Controller IP',
    username: 'Username',
    password: 'Password',
    ntlmHash: 'NTLM Hash (optional)',
    dcConfiguration: 'Domain Controller Configuration',
    attacks: 'AD Attacks',
    ldapPentest: 'LDAP/LDAPS Pentest',
    searchPlaceholder: 'Search for an attack, a tool...',
    allCategories: 'All categories',
    attackCategories: 'Attack Categories',
    targetResults: 'Target / Results',
    noDataMessage: 'Select an attack to start',
    noDataHint: 'Or use Auto PoC for an attack chain',
    readyToStart: 'Ready to start',
    stats: {
      attacks: 'Attacks',
      successful: 'Successful',
      failed: 'Failed',
      credentials: 'Credentials',
      users: 'Users',
      paths: 'Paths'
    },
    attackWizard: 'AD Attack Wizard',
    // PingCastleDetail
    backToAD: 'Back to AD page',
    auditRunning: 'AD Audit in progress',
    auditRunningDesc: 'Analyzing Active Directory {domain}... The page refreshes automatically.',
    auditFailed: 'Audit failed',
    globalRiskScore: 'Global risk score',
    scoresByCategory: 'Scores by category',
    noScoresCalculated: 'No scores calculated',
    auditInfo: 'Audit information',
    criticalIndicatorsPriority: 'Critical indicators to address with priority',
    riskScoreCritical: 'The domain has critical vulnerabilities requiring immediate action.',
    riskScoreHigh: 'Significant risks have been identified in the Active Directory domain.',
    riskScoreMedium: 'Some improvement areas to address with medium priority.',
    riskScoreLow: 'The domain presents a low risk level. Maintain best practices.',
    objectsAffected: '{count} object(s) affected',
    recommendedSolution: 'Recommended solution',
    noActionRequired: 'No action required',
    noRiskIndicators: 'The domain has no risk indicators.',
    immediateActions: 'Immediate actions',
    recommendedImprovements: 'Recommended improvements',
    prioritizedActionPlan: 'Prioritized action plan based on {count} detected indicators. Immediate actions (< 30d) must be addressed before generating AD reports.',
    generateAIAnalysis: 'Generate AI analysis',
    generateAIAnalysisDesc: 'The AI will analyze the {count} AD indicators to:',
    generatingAI: 'Analysis in progress…',
    generatingAIDesc: 'AI analyzes the {count} AD indicator(s) and generates the attack guide',
    generatingAITime: 'This may take 2 to 4 minutes depending on GPU server load',
    analysisGenerated: 'Analysis generated — {domain} · Score {score}/100 ({risk})',
    indicatorsAnalyzed: '{count} indicator(s) analyzed',
    regenerate: 'Regenerate',
    rawResponse: 'Raw response',
    analysisError: 'Note: Analysis used a fallback (AI service unavailable).',
    downloadEvidenceReport: 'Download evidence report (.txt)',
    noIndicatorsForFilter: 'No {filter} severity indicators.',
    noRiskIndicatorsDetected: 'No risk indicators detected.',
    statsDomainAdmins: 'Domain Admins',
    statsMaxPrivAccounts: 'Maximum privilege accounts',
    statsKerberoastable: 'Kerberoastable',
    statsInventory: 'Inventory',
    statsPrivilegedGroups: 'Privileged groups',
    statsKerberosDeleg: 'Kerberos & Delegation',
    statsOtherAnomalies: 'Other anomalies',
    statsInterpretation: 'Statistics interpretation',
    lapsDeployed: 'Deployed',
    lapsAbsent: 'Absent',
    highIndicators: 'High indicators',
    statusDone: '✓ Done',
    statusRunning: '⟳ Running',
    statusFailed: '✗ Failed',
    scanIdLabel: 'Scan ID',
    startedLabel: 'Started',
    completedLabel: 'Completed',
    // ADSessionDetail
    sessionStatusCompleted: 'Completed',
    sessionStatusFailed: 'Failed',
    sessionStatusStopped: 'Stopped',
    sessionStatusInitialized: 'Initialized',
    sessionTabOverview: 'Overview',
    sessionTabSteps: 'Steps',
    sessionTabFindings: 'Findings',
    sessionTabTimeline: 'Timeline',
    sessionTabAI: 'AI Analysis',
    sessionFindingsDetected: 'Findings detected',
    sessionStepsExecuted: 'Steps executed',
    sessionStepsFailed: '{count} failed, {skipped} skipped',
    sessionCredentialsFound: 'Credentials found',
    sessionCompromisedAccounts: 'Compromised accounts',
    sessionUsersEnumerated: 'Users enumerated',
    sessionDuration: 'Duration: {duration}',
    sessionDomainCompromised: 'Domain compromised',
    sessionDomainCompromisedDesc: 'The executed techniques have demonstrated the compromise of the Active Directory domain {domain}. Immediate action is required.',
    sessionAttackPathsFound: 'Attack paths identified',
    sessionAttackPathsDesc: 'Privilege escalation or lateral movement vectors have been identified in the domain.',
    sessionCriticalHighFindings: 'Critical / high findings',
    sessionStepsCompleted: 'Completed',
    sessionStepsSkipped: 'Skipped',
    sessionNoMatchingSteps: 'No matching steps',
    sessionNoFindingsDetected: 'No findings detected',
    sessionNoFindingsForFilter: 'No findings at this severity level.',
    sessionNoTimelineEvents: 'No timeline events',
    sessionStepsLabel: '{count} steps',
    sessionStepFindings: 'Step findings',
    sessionRecommendedRemediation: 'Recommended remediation',
    sessionAICompromiseGuide: 'AI Analysis — AD Compromise Guide',
    sessionAIWillAnalyze: 'The AI will analyze all findings and steps in this session to:',
    sessionAIExplainDiscoveries: 'Explain what was discovered',
    sessionAIIdentifyPaths: 'Identify attack paths',
    sessionAIStepByStep: 'Step-by-step AD compromise guide',
    sessionAIPriorityRecs: 'Priority remediation recommendations',
    sessionAILoading: 'Automatic AD compromise guide generation',
    sessionAILoadingTime: 'This may take 2-4 minutes — background processing',
    sessionAIAnalysisFor: 'Analysis generated for {domain}',
    sessionAIAnalysisMeta: '{steps} steps · {findings} findings analyzed',
    sessionAIAnalysisCredentials: '· {count} credentials',
    sessionDownloadEvidence: 'Download all evidence (.txt)',
    sessionOutputLabel: 'Output',
    sessionStepFindingsLabel: 'Step findings',
    sessionAIAnalysisGenerationTime: 'Generation via Ollama (sylink/sylink2:27b) — approximately 2-4 minutes'
  },

  // Notifications
  notifications: {
    managementCenter: 'Alerts and events management center',
    aiAssistant: 'AI Assistant',
    aiAssistantTitle: 'AI Assistant - Notifications',
    aiPlaceholder: 'Ask a question about your notifications...',
    settings: 'Notification settings',
    soundEnabled: 'Sound enabled',
    criticalOnly: 'Critical only',
    autoMarkRead: 'Auto mark read',
    filters: 'Filters',
    total: 'Total',
    unread: 'Unread',
    critical: 'Critical',
    warning: 'Warning',
    success: 'Success',
    info: 'Info',
    markAllRead: 'Mark all read',
    clearAll: 'Clear all',
    noNotifications: 'No notifications',
    noNotificationsDesc: 'You have no notifications at the moment',
    allRead: 'All your notifications are read',
    noNotificationsType: 'No notifications of type "{type}"',

    // Notification types
    typeCritical: 'Critical',
    typeWarning: 'Warning',
    typeSuccess: 'Success',
    typeInfo: 'Info',

    // Notification messages
    criticalVulnsFound: '{count} critical vulnerabilit{count, plural, =1 {y} other {ies}}',
    vulnsDetected: '{count} vulnerabilit{count, plural, =1 {y} other {ies}} detected',
    hostsScanned: '{count} hosts scanned on {target}',
    scanCompletedNoVulns: 'Scan completed - No vulnerabilities',
    noVulnsDetected: 'No vulnerabilities detected on {target}',
    scanInProgress: 'Scan in progress',
    analyzing: 'Analyzing {target}...',
    scanFailed: 'Scan failed',
    errorOn: 'Error on {target}',

    // Time
    justNow: 'Just now',
    minutesAgo: '{count}min ago',
    hoursAgo: '{count}h ago',
    daysAgo: '{count}d ago',
    scanRunning: 'Scan running',
    viewAll: 'View all notifications',
    scanCompleted: 'Scan completed'
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Autonomous',
    platformSubtitle: 'Pentest Platform',
    platformDescription: 'AI-powered security analysis with automated exploitation and detailed reports.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'Autonomous AI',
      description: 'AI pentester simulating a security expert',
      highlight: 'LLM On-Premise'
    },
    advancedDetection: {
      title: 'Advanced Detection',
      description: 'Automatic detection of critical flaws',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Complete Tests',
      description: 'Network, web, API and infra audit',
      highlight: '100+ tools'
    },
    instantReports: {
      title: 'Instant Reports',
      description: 'Automatic generation of professional reports',
      highlight: '6+ formats'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Availability',
    vulnerabilities: 'Vulnerabilities detected',
    monitoring: 'Monitoring',
    scanTime: 'Average scan time'
  },

  // Footer
  footer: {
    title: 'Security Scanner Platform',
    subtitle: 'Autonomous Penetration Testing System',
    terms: 'Terms of Use',
    termsShort: 'Terms of Use',
    sales: 'Terms of Sale',
    salesShort: 'Terms of Sale',
    privacy: 'Privacy Policy',
    legalNotice: 'Legal Notice',
    contact: 'Contact',
    version: 'Version',
    licence: 'Licence #',
    poweredBy: 'Powered by SYLink AI'
  },

  // Enrichment - ABSpider Integration
  enrichment: {
    title: 'Enrichment & Threat Intelligence',
    subtitle: 'Advanced domain and IP analysis with VirusTotal, security headers, email and geolocation',
    description: 'Analyze targets with multiple security intelligence sources',

    // Flat keys used by EnrichmentDashboard
    target: 'Target',
    type: 'Type',
    modules: 'Modules',
    quickScans: 'Quick Scans',
    threatSummary: 'Threat Intelligence Summary',
    recentScans: 'Recent Scans',
    riskScore: 'Risk Score',
    date: 'Date',
    noScans: 'No scans yet',
    scan: 'Scan',
    quickResult: 'Quick Scan Result',
    scanDetails: 'Scan Details',
    statusLabel: 'Status',

    // Navigation & Actions
    newScan: 'New scan',
    quickScan: 'Quick scan',
    fullScan: 'Full scan',
    viewDetails: 'View details',
    exportReport: 'Export report',
    refresh: 'Refresh',

    // Scan Types
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Security Headers',
      security_headers: 'Security Headers',
      email_security: 'Email Security',
      geoip: 'IP Geolocation',
      reverse_ip: 'Reverse IP',
      full: 'Full Scan',
      domain: 'Domain',
      ip: 'IP Address',
      url: 'URL',
      // Pentest scan types
      ai_scan: 'AI Scan',
      network_discovery: 'Network Discovery',
      vulnerability_scan: 'Vulnerability Scan',
      full_autonomous: 'Full Autonomous',
      full_auto: 'Full Autonomous',
      full_automation: 'Full Autonomous',
      expert: 'Expert Scan',
      api_pentest: 'API Pentest',
      iot_scan: 'IoT Scan',
      ot_scan: 'OT/SCADA Scan',
      ad_pentest: 'AD Pentest',
      ad_scan: 'Active Directory Scan',
      ad_recon: 'AD Reconnaissance',
      ad_full: 'Full AD Scan',
      ldap_scan: 'LDAP Scan',
      kerberos_scan: 'Kerberos Scan',
      web_scan: 'Web Scan',
      web: 'Web Scan',
      quick: 'Quick',
      quick_scan: 'Quick Scan',
      discovery: 'Discovery',
      enumeration: 'Enumeration',
      vulnerability: 'Vulnerabilities',
      exploitation: 'Exploitation',
      passive: 'Passive',
      aggressive: 'Aggressive',
      credentials: 'Credentials',
      recon: 'Reconnaissance',
      exploit: 'Exploitation',
      bypass: 'Bypass',
      nmap: 'Nmap Scan',
      nikto: 'Nikto Scan',
      internal: 'Internal Scan',
      external: 'External Scan',
      network: 'Network Scan'
    },

    // Status
    status: {
      pending: 'Pending',
      queued: 'Queued',
      running: 'Running',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled'
    },

    // Threat Levels
    threatLevels: {
      safe: 'Safe',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical'
    },

    // Form
    form: {
      targetDomain: 'Target domain',
      targetDomainPlaceholder: 'e.g.: example.com',
      targetIp: 'IP address (optional)',
      targetIpPlaceholder: 'e.g.: 192.168.1.1',
      scanType: 'Scan type',
      workspace: 'Workspace (optional)',
      startScan: 'Start scan',
      credits: 'Credits required'
    },

    // Results - General
    results: {
      title: 'Results',
      noResults: 'No results available',
      loading: 'Loading results...',
      riskScore: 'Risk score',
      threatLevel: 'Threat level',
      scannedAt: 'Scanned at',
      duration: 'Duration'
    },

    // Security Headers
    headers: {
      title: 'Security Headers Analysis',
      score: 'Score',
      grade: 'Grade',
      present: 'Present',
      missing: 'Missing',
      recommendations: 'Recommendations',
      headerName: 'Header',
      value: 'Value',
      status: 'Status',
      issues: 'Issues',
      gradeDescriptions: {
        A: 'Excellent - Optimal security',
        B: 'Good - Some improvements possible',
        C: 'Average - Improvements recommended',
        D: 'Poor - Significant improvements needed',
        F: 'Insufficient - Critical security to improve'
      }
    },

    // Email Security
    email: {
      title: 'Email Security',
      mxRecords: 'MX Records',
      spf: 'SPF (Sender Policy Framework)',
      dkim: 'DKIM (DomainKeys Identified Mail)',
      dmarc: 'DMARC (Domain-based Message Authentication)',
      valid: 'Valid',
      invalid: 'Invalid',
      notFound: 'Not found',
      policy: 'Policy',
      mechanisms: 'Mechanisms',
      selectors: 'Selectors',
      vulnerabilities: 'Detected vulnerabilities',
      recommendations: 'Recommendations'
    },

    // GeoIP
    geoip: {
      title: 'IP Geolocation',
      location: 'Location',
      country: 'Country',
      region: 'Region',
      city: 'City',
      coordinates: 'Coordinates',
      timezone: 'Timezone',
      network: 'Network information',
      isp: 'ISP',
      organization: 'Organization',
      asn: 'ASN',
      flags: 'Security flags',
      isProxy: 'Proxy detected',
      isVpn: 'VPN detected',
      isTor: 'Tor detected',
      isDatacenter: 'Datacenter',
      isHosting: 'Hosting'
    },

    // Reverse IP
    reverseIp: {
      title: 'Reverse IP Lookup',
      totalDomains: 'Domains found',
      domains: 'Domain list',
      sharedHosting: 'Shared hosting',
      hostingProvider: 'Hosting provider',
      suspiciousDomains: 'Suspicious domains',
      riskScore: 'Risk score'
    },

    // VirusTotal
    virustotal: {
      title: 'VirusTotal Analysis',
      reputation: 'Reputation',
      malicious: 'Malicious',
      suspicious: 'Suspicious',
      harmless: 'Harmless',
      undetected: 'Undetected',
      categories: 'Categories',
      lastAnalysis: 'Last analysis',
      permalink: 'VirusTotal link'
    },

    // Dashboard Stats
    stats: {
      totalScans: 'Total scans',
      completedScans: 'Completed scans',
      pendingScans: 'Pending scans',
      failedScans: 'Failed scans',
      averageScore: 'Average score',
      criticalThreats: 'Critical threats',
      highThreats: 'High threats',
      creditsUsed: 'Credits used'
    },

    // Error messages (used by EnrichmentDashboard)
    error: {
      targetRequired: 'Target is required',
      scanFailed: 'Failed to start scan',
      quickScanFailed: 'Quick scan failed',
      loadFailed: 'Failed to load scan details',
      deleteFailed: 'Failed to delete scan'
    },

    // Success messages (used by EnrichmentDashboard)
    success: {
      scanStarted: 'Scan started successfully',
      quickScanComplete: 'Quick scan completed',
      scanDeleted: 'Scan deleted'
    },

    // Errors (legacy)
    errors: {
      scanFailed: 'Scan failed',
      insufficientCredits: 'Insufficient credits',
      invalidDomain: 'Invalid domain',
      invalidIp: 'Invalid IP address',
      networkError: 'Network error',
      timeout: 'Timeout exceeded',
      unknownError: 'Unknown error'
    },

    // Tooltips
    tooltips: {
      virusTotalCredit: 'Uses VirusTotal API to analyze reputation',
      headersCredit: 'Analyzes HTTP security headers',
      emailCredit: 'Checks SPF, DKIM and DMARC',
      geoipCredit: 'Geolocates the IP address',
      reverseIpCredit: 'Finds domains hosted on the same IP',
      fullCredit: 'Performs all analyses'
    },

    // Recent Indicators
    recentIndicators: 'Recent Indicators',

    // AI Analysis
    aiAnalysis: {
      title: 'AI Analysis',
      executiveSummary: 'Executive summary',
      keyFindings: 'Key findings',
      recommendations: 'Recommendations'
    }
  },

  // Antivirus (ClamAV)
  antivirus: {
    title: 'Antivirus Scanner',
    subtitle: 'Scan files for malware using ClamAV',
    scannerTab: 'File Scanner',
    adminTab: 'Administration',
    adminTitle: 'Antivirus Management',
    adminSubtitle: 'ClamAV monitoring and quarantine management',
    scanFile: 'Scan File',
    scanNow: 'Scan Now',
    scanAll: 'Scan All Files',
    scanning: 'Scanning...',
    dropOrClick: 'Drop file or click to select',
    dropFiles: 'Drop files here or click to select',
    maxSize: 'Maximum size per file',
    selectedFiles: 'Selected Files',
    recentScans: 'Recent Scans',
    summary: 'Scan Summary',

    // Status
    clean: 'Clean',
    infected: 'Infected',
    pending: 'Pending',
    unavailable: 'ClamAV Unavailable',

    // Stats
    totalScans: 'Total Scans',
    cleanFiles: 'Clean Files',
    infectedFiles: 'Infected Files',
    dataScanned: 'Data Scanned',
    threatsBySeverity: 'Threats by Severity',
    performance: 'Performance',
    avgScanTime: 'Avg Scan Time',
    cacheEntries: 'Cache Entries',

    // Table headers
    filename: 'Filename',
    size: 'Size',
    status: 'Status',
    threat: 'Threat',
    severity: 'Severity',
    scannedAt: 'Scanned',

    // ClamAV
    daemonStatus: 'Daemon Status',
    version: 'Version',
    signatureVersion: 'Signature Version',
    signatureCount: 'Signatures',
    reloadSignatures: 'Reload Signatures',

    // Quarantine
    quarantine: 'Quarantine',
    noQuarantine: 'No files in quarantine',
    quarantinedAt: 'Quarantined',
    expiresAt: 'Expires',
    cleanupExpired: 'Cleanup Expired',
    confirmDelete: 'Are you sure you want to permanently delete this file?',

    // Errors
    fileTooLarge: 'File too large',
    typeNotAllowed: 'File type not allowed',
    total: 'Total'
  },

  // Contracts & Signature
  contracts: {
    title: 'Contracts',
    newContract: 'New Contract',
    contractNumber: 'Contract Reference',
    status: 'Status',
    draft: 'Draft',
    pendingSignature: 'Pending Signature',
    signed: 'Signed',
    active: 'Active',
    completed: 'Completed',
    expired: 'Expired',
    cancelled: 'Cancelled',

    // Signature
    signature: {
      title: 'Electronic Signature',
      certificate: 'Electronic Signature Certificate',
      signatory: 'Signatory',
      signatoryName: 'Signatory Name',
      signatoryEmail: 'Signatory Email',
      signatoryFirstName: 'First Name',
      signatoryLastName: 'Last Name',
      signatureDate: 'Signature Date & Time',
      signatureType: 'Signature Type',
      drawn: 'Drawn',
      typed: 'Typed',
      uploaded: 'Uploaded',
      legalMention: 'Legal Mention',
      acceptPentest: 'Acknowledged for Pentest Authorization',

      // Verification
      verification: 'Verification',
      smsVerification: 'SMS Verification',
      smsVerified: 'Verified',
      smsPending: 'Pending',
      ipAddress: 'IP Address',
      userAgent: 'Browser',
      geolocation: 'Geolocation',

      // Integrity
      integrity: 'Document Integrity',
      documentHash: 'Document Hash',
      signatureHash: 'Signature Hash',
      hashAlgorithm: 'Algorithm',
      sha512: 'SHA-512',

      // Timeline
      timeline: 'Timeline',
      createdAt: 'Created',
      sentAt: 'Sent',
      viewedAt: 'Viewed',
      signedAt: 'Signed',
      viewCount: 'View Count',

      // Audit trail
      auditTrail: 'Audit Trail',
      action: 'Action',
      timestamp: 'Timestamp',
      viewed: 'Viewed',
      smsRequested: 'SMS Code Requested',
      smsVerifiedAction: 'SMS Code Verified',
      signedAction: 'Signature Completed',
      downloaded: 'Downloaded',

      // Certificate
      certificateType: 'CERTIFICATE OF COMPLETION',
      platform: 'Platform',
      eidas: 'Electronic signature compliant with eIDAS regulation (EU) 910/2014',
      generatedAt: 'Certificate generated on',

      // Actions
      downloadProof: 'Download Signature Proof',
      viewCertificate: 'View Certificate',
      resendEmail: 'Resend by Email',

      // Messages
      contractSigned: 'Contract signed successfully!',
      copySentByEmail: 'A copy of this certificate will be sent by email.',
      enterSmsCode: 'Enter SMS Code',
      smsCodeSent: 'SMS code sent',
      invalidCode: 'Invalid code',
      codeExpired: 'Code expired',
      tooManyAttempts: 'Too many attempts'
    }
  },

  // VPN Configuration
  vpn: {
    title: 'VPN Configuration',
    configurations: 'VPN Configurations',
    noConfigurations: 'No VPN configurations',
    uploadConfig: 'Upload configuration',
    connected: 'Connected',
    disconnected: 'Disconnected',
    connecting: 'Connecting...',
    disconnecting: 'Disconnecting...',
    connect: 'Connect',
    disconnect: 'Disconnect',
    server: 'Server',
    saveCredentials: 'Save credentials for this VPN',
    status: 'VPN Status',
    protocol: 'Protocol',
    interface: 'Interface',
    publicIp: 'Public IP',
    vpnIp: 'VPN IP',
    country: 'Country',
    city: 'City',
    connectedSince: 'Connected since',

    // Routes
    routes: {
      title: 'Network Routes',
      description: 'Manage custom network routes for VPN',
      addRoute: 'Add route',
      destination: 'Destination CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Gateway',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Description',
      routeDescriptionPlaceholder: 'Client internal network',
      noRoutes: 'No routes configured',
      deleteRoute: 'Delete route',
      applyRoutes: 'Apply routes',
      routeAdded: 'Route added successfully',
      routeDeleted: 'Route deleted',
      routesApplied: 'Routes applied',
      invalidCidr: 'Invalid CIDR format',
      invalidGateway: 'Invalid IP address',
      active: 'Active',
      inactive: 'Inactive'
    },

    // Network Topology
    topology: {
      title: 'Network Topology',
      server: 'Sylink Server',
      internet: 'Internet',
      vpnGateway: 'VPN Gateway',
      clientNetwork: 'Client Network',
      online: 'Online',
      offline: 'Offline',
      activeRoutes: 'Active routes',
      totalRoutes: 'Total routes',
      networkGateway: 'Network Gateway',
      subnetsCount: '{{count}} subnets'
    },

    // Messages
    messages: {
      configUploaded: 'VPN configuration uploaded',
      configDeleted: 'VPN configuration deleted',
      connectionSuccess: 'VPN connected successfully',
      connectionFailed: 'VPN connection failed',
      disconnectionSuccess: 'VPN disconnected',
      disconnectionFailed: 'VPN disconnection failed',
      saveError: 'Error saving credentials',
      deleteError: 'Error deleting credentials',
      connectError: 'VPN connection error',
      disconnectError: 'VPN disconnection error'
    },
    // Panel strings
    loadingWorkspaces: 'Loading workspaces...',
    noWorkspace: 'No workspace',
    noWorkspaceAvailable: 'No workspace available',
    noVpnFoundFor: 'No VPN found for "{query}"',
    deleteStoredCredentialsTitle: 'Delete stored credentials',
    saveCredentialsSecurely: 'Save credentials securely',
    saveCredentialsNow: 'Save now',
    noVpnAvailable: 'No VPN configuration available',
    loadingConfigs: 'Loading VPN configurations...'
  },

  // Phishing Simulation
  phishing: {
    title: 'Phishing Simulation',
    subtitle: 'Test employee security awareness with simulated phishing campaigns',
    campaignsTab: 'Campaigns',
    templatesTab: 'Templates',
    targetsTab: 'Target Groups',
    analyticsTab: 'Analytics',
    settingsTab: 'Settings',
    totalCampaigns: 'Total Campaigns',
    emailsSent: 'Emails Sent',
    clickRate: 'Click Rate',
    reportRate: 'Report Rate',
    recentCampaigns: 'Recent Campaigns',
    newCampaign: 'New Campaign',
    campaignName: 'Campaign Name',
    status: 'Status',
    sent: 'Sent',
    opened: 'Opened',
    clicked: 'Clicked',
    reported: 'Reported',
    actions: 'Actions',
    viewDetails: 'View Details',
    emailTemplates: 'Email Templates',
    createTemplate: 'Create Template',
    targetGroups: 'Target Groups',
    createGroup: 'Create Group',
    groupName: 'Group Name',
    members: 'Members',
    lastUsed: 'Last Used',
    edit: 'Edit',
    delete: 'Delete',
    analyticsOverview: 'Analytics Overview',
    clickRateTrend: 'Click Rate Trend',
    reportRateTrend: 'Report Rate Trend',
    chartPlaceholder: 'Chart will display here',
    departmentComparison: 'Department Comparison',
    settings: 'Phishing Settings',
    smtpConfig: 'SMTP Configuration',
    smtpServer: 'SMTP Server',
    smtpPort: 'SMTP Port',
    trackingSettings: 'Tracking Settings',
    trackOpens: 'Track email opens',
    trackClicks: 'Track link clicks',
    trackSubmissions: 'Track credential submissions',
    saveSettings: 'Save Settings',
    reference: 'Reference',
    statusCompleted: 'Completed',
    statusActive: 'Active',
    statusScheduled: 'Scheduled',
    statusCancelled: 'Cancelled',
    statusDraft: 'Draft',
    categoryCredentialHarvest: 'Credential Harvest',
    categoryLinkClick: 'Link Click',
    categoryAttachment: 'Attachment'
  },

  // Sankey Analysis
  sankey: {
    title: 'Security Flow - Flow Diagram',
    clickForAiAnalysis: 'Click on an element for AI analysis',
    exploitable: 'Exploitable',
    nonExploitable: 'Non Exploitable',
    columns: {
      workspaces: 'Workspaces',
      targets: 'Targets',
      assets: 'Assets',
      vulnerabilities: 'Vulnerabilities',
      exploitability: 'Exploitability',
      cve: 'CVE'
    },
    legend: {
      workspaces: 'Workspaces',
      targets: 'Targets',
      critical: 'Critical',
      nonExploitable: 'Non Exploit.'
    },
    severity: {
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low'
    },
    analysis: {
      model: 'Model',
      changeModel: 'Analyze with another LLM',
      selectModel: 'Select an LLM model',
      regenerateWith: 'Regenerate analysis with another model',
      recommended: 'Recommended',
      regenerate: 'Regenerate analysis'
    },
    noScansAvailable: 'No scans available for visualization',
    scansLabel: 'scans',
    hostsLabel: 'hosts',
    portsLabel: 'ports',
    occurrences: 'occurrence(s)',
    tooltip: {
      element: 'Element',
      scansHostsVulns: '{scans} scans • {hosts} hosts • {vulns} vulnerabilities',
      ipHostsVulns: '{ip} • {hosts} hosts • {vulns} vulnerabilities',
      vulnsCount: '{count} vulnerabilities',
      clickForAi: 'Click for AI analysis'
    },
    stats: {
      workspaces: 'Workspaces',
      targets: 'Targets',
      assets: 'Assets',
      vulnerabilities: 'Vulnerabilities',
      exploitable: 'Exploitable'
    }
  },

  // LLM Monitor
  llmMonitor: {
    title: 'LLM Orchestrator',
    subtitle: 'Model management and supervision with GPU acceleration',
    gpuStatus: 'GPU Status',
    vram: 'VRAM',
    utilization: 'Utilization',
    load: 'Load',
    loaded: 'Loaded',
    noTarget: 'No target',
    entries: 'entries',
    vulnerabilities: 'vulnerabilities',
    credentials: 'credentials',
    poolStatus: 'GPU Pool Status',
    servers: 'servers',
    moreModels: 'more',
    orchestratorMetrics: 'Orchestrator Metrics',
    totalRequests: 'Total Requests',
    modelSwaps: 'Model Swaps',
    avgSwapTime: 'Avg. Swap Time',
    inferences: 'Inferences',
    connected: 'Connected',
    disconnected: 'Disconnected',
    refresh: 'Refresh',
    availableModels: 'Available Models',
    activeSessions: 'Active Sessions',
    noActiveSessions: 'No active sessions',
    noSessionsHint: 'LLM sessions use artificial intelligence to automatically analyze vulnerabilities, generate reports, and coordinate penetration testing.',
    noSessionsAction: 'Start a session',
    readyStatus: 'Ready to start',
    howToStart: 'Launch a scan to start an LLM session',
    waitingForScan: 'Waiting for scan',
    quickActions: 'Quick Actions',
    newSession: 'New Session',
    requestCheckpoint: 'Request Checkpoint',
    hashcatTasks: 'Hashcat Tasks',
    loadStatusFailed: 'Failed to load LLM status',
    loadingModel: 'Loading {{model}}...',
    swapFailed: 'Failed to swap model',
    noModel: 'None',
    online: 'Online',
    offline: 'Offline',
    serviceUnavailable: 'LLM service unavailable'
  },

  // Tool Categories (for ToolsList)
  toolCategories: {
    reconnaissance: 'Reconnaissance',
    web: 'Web Scan',
    cms: 'CMS Scanners',
    vulnerabilities: 'Vulnerability Scanners',
    bruteforce: 'Brute Force',
    ad: 'Active Directory',
    ldap: 'LDAP / LDAPS',
    services: 'Service Enumeration',
    osint: 'Open Source Intelligence (OSINT)',
    suites: 'Security Suites',
    ssl: 'SSL/TLS',
    ot: 'OT/ICS/SCADA',
    iot: 'IoT Devices',
    pivoting: 'Pivoting & Tunneling',
    privesc: 'Privilege Escalation',
    evasion: 'Evasion & Bypass',
    supply_chain: 'Supply Chain Security',
    network_attack: 'Network Attacks',
    firewall: 'Firewall / Router / Box',
    vpn: 'VPN Security',
    cloud: 'Cloud Security',
    other: 'Other'
  },

  // OSINT translations (used by ScansList.jsx translateScanType)
  osint: {
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Security Headers',
      security_headers: 'Security Headers',
      email_security: 'Email Security',
      geoip: 'IP Geolocation',
      reverse_ip: 'Reverse IP',
      full: 'Full Scan',
      domain: 'Domain',
      ip: 'IP Address',
      url: 'URL',
      network_discovery: 'Network Discovery',
      vulnerability_scan: 'Vulnerability Scan',
      full_autonomous: 'Full Autonomous',
      full_auto: 'Full Autonomous',
      full_automation: 'Full Autonomous',
      expert: 'Expert Scan',
      api_pentest: 'API Pentest',
      iot_scan: 'IoT Scan',
      ot_scan: 'OT/SCADA Scan',
      ad_pentest: 'AD Pentest',
      ad_scan: 'Active Directory Scan',
      ad_recon: 'AD Reconnaissance',
      ad_full: 'Full AD Scan',
      ldap_scan: 'LDAP Scan',
      kerberos_scan: 'Kerberos Scan',
      web_scan: 'Web Scan',
      web: 'Web Scan',
      quick: 'Quick',
      quick_scan: 'Quick Scan',
      discovery: 'Discovery',
      enumeration: 'Enumeration',
      vulnerability: 'Vulnerability',
      exploitation: 'Exploitation',
      passive: 'Passive',
      aggressive: 'Aggressive',
      credentials: 'Credentials',
      recon: 'Reconnaissance',
      exploit: 'Exploitation',
      bypass: 'Bypass',
      nmap: 'Nmap Scan',
      nikto: 'Nikto Scan',
      internal: 'Internal Scan',
      external: 'External Scan',
      network: 'Network Scan',
      // OWASP/ZAP related scan types
      owasp: 'OWASP Scan',
      owasp_scan: 'OWASP Scan',
      owasp_top10: 'OWASP Top 10',
      owasp_top_10: 'OWASP Top 10',
      zap: 'ZAP Scan',
      zap_scan: 'ZAP Scan',
      owasp_zap: 'OWASP ZAP Scan',
      // Additional scan types
      sqlmap: 'SQLMap Scan',
      openvas: 'OpenVAS Scan',
      nuclei: 'Nuclei Scan',
      metasploit: 'Metasploit Scan',
      hydra: 'Hydra Test',
      wpscan: 'WordPress Scan',
      gobuster: 'Gobuster Scan',
      pentest: 'Pentest',
      stealth: 'Stealth Scan',
      full_scan: 'Full Scan',
      standard: 'Standard'
    }
  },

  // Severity levels (used across components)
  severity: {
    critical: 'Critical',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    info: 'Info'
  },

  // Agents
  agents: {
    title: 'Agents',
    subtitle: 'Scan agents deployed on internal networks',
    loading: 'Loading agents...',
    register: 'Register',
    registerAgent: 'Register an Agent',
    downloadInstaller: 'Download installer',
    searchPlaceholder: 'Search for an agent...',
    noAgentsFound: 'No agents found',
    noAgentsRegistered: 'No agents registered',
    noAgentsFoundHint: 'Modify your search or register a new agent',
    noAgentsRegisteredHint: 'Deploy an agent on a client network to scan internal targets without VPN',
    loadError: 'Error loading agents',
    deleteConfirm: 'Delete agent "{name}"?',
    // Table columns
    colAgent: 'Agent',
    colStatus: 'Status',
    colHostname: 'Hostname',
    colInternalIp: 'Internal IP',
    colLastSeen: 'Last connection',
    colMetrics: 'Metrics',
    colActions: 'Actions',
    never: 'Never',
    details: 'Details',
    delete: 'Delete',
    // Stats
    statTotal: 'Total',
    statOnline: 'Online',
    statOffline: 'Offline',
    statBusy: 'Busy',
    // AgentDetails
    loadingAgent: 'Loading agent...',
    agentNotFound: 'Agent not found',
    backToAgents: 'Back to agents',
    pingAgent: 'Ping',
    pinging: 'Ping...',
    systemCard: 'System',
    networkCard: 'Network',
    registeredCard: 'Registered',
    tunnelActive: 'Tunnel active',
    polling: 'Polling',
    avg24h: 'avg. 24h',
    recentTasks: 'Recent Tasks',
    noTasksExecuted: 'No tasks executed'
  },

  // Equipment types (for EquipmentDashboard)
  equipmentTypes: {
    deleteConfirm: 'Are you sure you want to delete this equipment?',
    launchAttack: 'Launch attack',
    validateDetection: 'Validate detection',
    deleteEquipment: 'Delete',
    deleted: 'Equipment deleted',
    validationError: 'Validation error',
    deleteError: 'Deletion error',
    categories: {
      server: 'Server',
      workstation: 'Workstation',
      network: 'Network',
      security: 'Security',
      iot: 'IoT',
      ot_ics: 'OT/ICS',
      mobile: 'Mobile',
      cloud: 'Cloud',
      container: 'Container',
      database: 'Database',
      web_application: 'Web Application',
      printer: 'Printer',
      storage: 'Storage',
      voip: 'VoIP',
      other: 'Other'
    }
  },

  // Sessions (extra keys for SessionDetails/SessionsList)
  sessionsExtra: {
    sessionNotFound: 'Session not found',
    privescConfirm: 'Launch a privilege escalation attempt?',
    validateForReport: 'Validate for report',
    chainNames: {
      full_recon: 'Full Reconnaissance',
      cred_harvest: 'Credential Harvesting',
      pivot_recon: 'Pivot Discovery',
      safe_migrate: 'Safe Migration'
    },
    aptModules: 'APT Modules (Advanced Persistent Threat)',
    modulesAvailable: 'modules available'
  },

  // NetworkMap extra keys
  networkMap: {
    launchOwaspAnalysis: 'Web services - Launch OWASP analysis',
    launchSimulation: 'Launch Simulation'
  },

  // ScanDetails extra keys
  scanDetails: {
    viewScanConfig: 'View scan configuration',
    downloadPdfReport: 'Download PDF report',
    pdfReport: 'PDF Report',
    relaunch: 'Retry',
    relaunchScan: 'Retry this scan with the same parameters',
    schedule: 'Schedule',
    scheduleScan: 'Schedule this scan',
    refresh: 'Refresh',
    vpnConnectionRequired: 'VPN Connection Required',
    vpnConnectionRequired2: 'This scan requires a VPN connection to access the internal network',
    vpnConnectInstructions: 'Please connect to the VPN configured for this workspace, then restart the scan or wait for the connection to be established.',
    configureVpn: 'Configure VPN',
    viewWorkspaces: 'View Workspaces',
    vpnConnection: 'VPN Connection',
    scanServer: 'Scan Server',
    vpnActive: 'VPN Active',
    directConnection: 'Direct Connection',
    vpnServer: 'VPN Server',
    hostsDiscovered: 'Discovered Hosts',
    hostsDiscoveredDesc: 'Total number of machines (servers, network equipment, workstations) discovered and accessible on the scanned perimeter. Each host represents a potential attack surface.',
    totalVulnerabilities: 'Total Vulnerabilities',
    totalVulnerabilitiesDesc: 'Total number of security flaws (CVEs) identified across all hosts. Each CVE represents a known and documented vulnerability that could be exploited by an attacker.',
    criticalVulnerabilities: 'Critical Vulnerabilities',
    criticalVulnerabilitiesDesc: 'CVSS 9.0-10.0: Flaws allowing total system compromise (remote code execution, root privilege escalation). Immediate action required.',
    immediateActionRequired: 'Immediate action required.',
    scanConfiguration: 'Scan Configuration',
    target: 'Target',
    scanType: 'Scan type',
    createdAt: 'Created on',
    intensity: 'Intensity',
    queueHowItWorks: 'How does the queue work?',
    queueOrdered: 'Scans are processed in order of arrival with priority based on your plan',
    queueAutoUpdate: 'This page updates automatically - stay here or come back later',
    queueAutoStart: 'The scan will start automatically as soon as a resource is available',
    accelerateScans: 'Accelerate your scans',
    accelerateDesc: 'For reduced wait times and priority scans, several options are available:',
    proPlanOption: 'Pro or Enterprise Plan',
    proPlanDesc: 'Get higher priority in the queue and reduced wait times',
    dedicatedServer: 'Dedicated Server',
    dedicatedServerDesc: 'Instant scans without queue - your own dedicated resources',
    viewPlans: 'View plans',
    noVulnDetected: 'No vulnerabilities detected',
    showTop5: 'Show 5 most severe',
    showAll: 'Show all',
    viewAll: 'View all',
    viewDetails: 'View details',
    showingTop5: 'Showing top 5 {sortType} vulnerabilities out of {total} total',
    bySeverity: 'most severe',
    byDate: 'most recent',
    capturedOn: 'Captured on',
    imageLoadError: 'Image loading error',
    autoGenerateReport: 'Auto-generate report',
    selectReportFormats: 'Select report format(s) to generate',
    reportFormats: 'Report formats',
    reduceList: 'Collapse list',
    showMoreHosts: 'Show {count} more hosts',
    stopScanConfirm: 'Are you sure you want to stop this scan?',
    deleteScanConfirm: 'Are you sure you want to delete this scan?',
    retryScanConfirm: 'Retry this scan with the same parameters?',
    stopScanFailed: 'Failed to stop scan',
    deleteScanFailed: 'Failed to delete scan',
    cleanupFailed: 'Cleanup failed',
    immediatePatching: 'Immediate patching',
    immediatePatchingDesc: 'Apply security patches for identified critical and high vulnerabilities.',
    reduceAttackSurface: 'Reduce attack surface',
    reduceAttackSurfaceDesc: 'Close non-essential ports and limit service exposure.',
    updateComponents: 'Update components',
    updateComponentsDesc: 'Update vulnerable software to their latest secure versions.',
    continuousMonitoring: 'Continuous monitoring',
    continuousMonitoringDesc: 'Set up log monitoring and alerts to detect any suspicious activity.',
    noCriticalVulnsDetected: 'No critical vulnerabilities detected',
    majorityLowSeverity: 'Majority of low severity vulnerabilities',
    fullCoverageMultipleTools: 'Full coverage with multiple analysis tools',
    automatedScanFastDetection: 'Automated scan enabling rapid detection',
    aiAssistedReport: 'Report generated with AI assistance for in-depth analysis',
    implementSecurityRecommendations: 'Implement security recommendations',
    strengthenNetworkSegmentation: 'Strengthen network segmentation',
    vulnManagementProgram: 'Vulnerability management program',
    regularSecurityAudits: 'Regular security audits',
    securityAwarenessTraining: 'Security awareness training',
    hostsLabel: 'Hosts',
    vulnerabilitiesLabel: 'Vulnerabilities',
    criticalLabel: 'Critical',
    highLabel: 'High',
    mediumLabel: 'Medium',
    lowLabel: 'Low',
    highVulnsDesc: 'CVSS 7.0-8.9: Flaws that can lead to unauthorized access or sensitive data leakage. Priority correction recommended.',
    mediumVulnsDesc: 'CVSS 4.0-6.9: Flaws requiring specific conditions to be exploited. To be fixed within a reasonable timeframe.',
    lowVulnsDesc: 'CVSS 0.1-3.9: Flaws with limited impact, often informational or requiring prior access. To be addressed during planned maintenance.',
    duration: 'Duration',
    remainingTime: 'Remaining',
    aiModel: 'AI',
    capturesResults: 'Captures & Results',
    restartScanFailed: 'Failed to restart scan',
    runningScheduledScans: 'Running / scheduled scans',
    runningScansSection: 'Running scans',
    scheduledScansSection: 'Scheduled scans',
    identifiedCves: 'Identified CVEs',
    detailedVulnerabilities: 'Detailed vulnerabilities',
    remediationRecommendations: 'Remediation recommendations',
    recPriorityUrgent: 'URGENT',
    recPriorityPriority: 'PRIORITY',
    recPriorityRecommended: 'RECOMMENDED',
    scheduleNext: 'Next',
    scheduleAt: 'at',
    freeToSchedule: 'You can schedule freely',
    executionTime: 'Execution time',
    timezoneEuropeParis: 'Timezone: Europe/Paris',
    limitExecutions: 'Limit number of executions',
    autoStopAfterDesc: 'Automatically stop after X scans',
    endAfter: 'End after',
    executionsUnit: 'execution(s)',
    summaryLabel: 'Summary',
    noDaySelected: 'no day selected',
    schedulePrefix: 'The scan will run',
    scheduleSummaryWeekly: 'every week ({days})',
    scheduleSummaryMonthly: 'every month (1st {day})',
    scheduleSummaryQuarterly: 'every 3 months (1st {day})',
    scheduleSummarySemestrial: 'every 6 months (1st {day})',
    scheduleSummaryYearly: 'every year (1st {day})',
    forNExecutions: 'for {count} execution(s)',
    reportsLabel: 'Report(s)',
    scheduleRunRule: 'The scan will run on the first {day} {period}',
    freqEveryMonth: 'every month',
    freqEveryQuarter: 'every quarter',
    freqEvery6Months: 'every 6 months',
    freqEveryYear: 'every year',
    daysOfWeek: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday'
    },
    daysOfWeekShort: {
      sun: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat'
    },
    daysOfWeekMini: {
      sun: 'Su',
      mon: 'Mo',
      tue: 'Tu',
      wed: 'We',
      thu: 'Th',
      fri: 'Fr',
      sat: 'Sa'
    },
    daysOfTheWeekLabel: 'Days of the week',
    dayOfTheWeekLabel: 'Day of the week',
    frequencyLabel: 'Frequency',
    scheduleThisScan: 'Schedule this scan',
    configureRecurrence: 'Configure the recurrence to automatically relaunch this scan on {target}',
    detectedServices: 'Detected services',
    discoveredHosts: 'Discovered hosts',
    manageAllVulnerabilities: 'Manage all vulnerabilities →',
    aiFeedback: 'AI Feedback',
    aiFeedbackDesc: 'Help us improve AI results by explaining what is not correct.',
    executiveReportDesc: 'This executive report was automatically generated by our cybersecurity AI {brand}. It deeply analyzes scan results to identify critical risks, assess business impact, and provide actionable recommendations tailored to your context.',
    modelLabel: 'Model',
    alertExploitedVulns: '⚠️ ALERT: Confirmed Exploited Vulnerabilities',
    aiConfirmedExploitation: 'The AI confirmed successful exploitation of {count} vulnerability(ies).',
    immediateRiskFlaws: 'These flaws represent an immediate risk and require emergency action.',
    generalInformation: 'General information',
    networkMode: 'Network mode',
    vpnConfiguration: 'VPN Configuration',
    artificialIntelligence: 'Artificial intelligence',
    aiModelLabel: 'AI Model',
    analysisDepth: 'Analysis depth',
    assistanceMode: 'Assistance mode',
    activeAiAnalysis: 'Active AI analysis',
    enabledTools: 'Enabled tools',
    securityOptions: 'Security options',
    safeMode: 'Safe mode',
    evasion: 'Evasion',
    simulationMode: 'Simulation mode',
    darkWebSearch: 'Dark Web search',
    severityFilters: 'Severity filters',
    nameLabel: 'Name',
    targetLabel: 'Target',
    scanTypeLabel: 'Scan type',
    unnamed: 'Unnamed',
    userLabel: 'User',
    configurationLabel: 'Configuration',
    queuedStatus: 'Queued',
    impactIdentified: 'Impact identified',
    excludedFromReport: 'Excluded from report',
    analyzeWithAI: 'Analyze with AI',
    networkScanMode: 'Network scan mode',
    networkScanModeDesc: 'Choose how scan traffic will be routed. For internal networks, use VPN Client-to-Site.',
    scanSpeed: 'Scan speed',
    timingDesc: {
      paranoidLabel: 'Paranoid',
      paranoidDesc: 'Very slow',
      sneakyLabel: 'Sneaky',
      sneakyDesc: 'Slow',
      normalLabel: 'Normal',
      normalDesc: 'Balanced',
      aggressiveLabel: 'Aggressive',
      aggressiveDesc: 'Fast',
      insaneLabel: 'Extreme',
      insaneDesc: 'Very fast'
    },
    osDetectionTitle: 'OS detection',
    osDetectionDesc: 'Identify operating systems',
    serviceDetectionTitle: 'Service detection',
    serviceDetectionDesc: 'Detect service versions',
    scriptScanTitle: 'Script scan',
    scriptScanDesc: 'Run NSE scripts',
    aggressiveModeTitle: 'Aggressive mode',
    aggressiveModeDesc: 'Enable all detection features',
    advancedOptionsTitle: 'Advanced options',
    advancedOptionsDesc: 'These options may impact scan performance and detectability. Use with caution.',
    scanConfigSummary: 'Scan configuration summary',
    basicConfig: 'Basic configuration',
    scanOptionsLabel: 'Scan options',
    maxRetries: 'Max retries',
    timeoutLabel: 'Timeout',
    excludedHosts: 'Excluded hosts',
    estimatedDuration: 'Estimated duration',
    estDurationDiscovery: 'Approximately 5-15 minutes depending on network size',
    estDurationVulnScan: 'Approximately 30-60 minutes depending on targets',
    estDurationFullAutonomous: 'Approximately 1-2 hours for a complete assessment',
    enabledLabel: 'Enabled',
    disabledLabel: 'Disabled',
    portsCommon: 'Common',
    portsAll: 'All',
    modeLabelInline: 'Mode',
    speedLabelInline: 'Speed',
    selectedLabel: 'Selected',
    iot: {
      defaultCreds: 'Default creds',
      vulnerable: 'Vulnerable',
      vendorLabel: 'Vendor',
      openPortsLabel: 'Open ports',
      unknownDevice: 'Unknown device',
      loadingScanDetails: 'Loading IoT scan details…',
      backToScans: 'Back to Scans',
      couldNotLoad: 'The IoT scan could not be loaded.',
      tabOverview: 'Overview',
      tabDevices: 'Devices',
      tabVulnerabilities: 'Vulnerabilities',
      scanProgress: 'Scan Progress',
      riskAssessment: 'Risk Assessment',
      overallRiskDesc: 'Overall security risk based on discovered vulnerabilities',
      riskScore: 'Risk Score',
      scanInformation: 'Scan Information',
      targetLabel: 'Target',
      scanTypeLabel: 'Scan Type',
      protocolsLabel: 'Protocols',
      createdLabel: 'Created',
      startedLabel: 'Started',
      completedLabel: 'Completed',
      deviceTypes: 'Device Types',
      noDevicesFound: 'No devices found',
      vulnDistributionBySeverity: 'Vulnerability distribution by severity',
      noIoTDevicesFound: 'No IoT Devices Found',
      noIoTDevicesDesc: 'The scan did not discover any IoT devices on the target network.',
      noVulnsFound: 'No Vulnerabilities Found',
      noVulnsFoundDesc: 'The scan did not identify any security vulnerabilities.'
    },
    freqLabel: {
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      quarterly: 'Quarterly',
      semestrial: 'Semestrial',
      yearly: 'Yearly'
    },
    reportFormatLabels: {
      pentest: 'Pentest Report',
      remediation: 'Remediation',
      comex: 'Comex',
      cveJson: 'JSON CVE',
      pentestShort: 'Pentest',
      remediationShort: 'Remediation',
      comexShort: 'Comex',
      cveJsonShort: 'JSON CVE'
    }
  },

  // Subdomains
  subdomains: {
    title: 'Subdomain Discovery',
    description: 'Discover subdomains and launch automated attacks',
    searchTitle: 'Subdomain Search',
    domainPlaceholder: 'example.com',
    scanning: 'Scanning...',
    quickScan: 'Quick scan',
    fullScan: 'Full scan',
    toolsLabel: 'Tools used by the full scan',
    sessionExpired: 'Session expired. Please log in again.',
    discoveryError: 'Error during subdomain discovery',
    networkError: 'Network error. Check your connection.',
    enterDomain: 'Please enter a domain',
    selectAtLeastOne: 'Select at least one subdomain',
    subdomainsDiscovered: '{count} subdomains discovered',
    savedToWorkspace: ' — saved to workspace',
    totalDiscovered: 'Total Discovered',
    active: 'Active (Resolvable)',
    selected: 'Selected',
    duration: 'Duration',
    selectAllActive: 'Select all active',
    deselectAll: 'Deselect all',
    scanSelected: 'Scan selected ({count})',
    attacking: 'Attacking...',
    scansLaunched: '{count} scan(s) launched on selected subdomains',
    discoveredSubdomains: 'Discovered subdomains',
    noAliveSubdomains: 'No alive subdomains found',
    noAliveSubdomainsDesc: 'This domain may not have publicly indexed subdomains',
    resultsByTool: 'Results by tool',
    emptyStateTitle: 'Subdomain Discovery',
    emptyStateDesc: 'Enter a domain above to discover all its subdomains.',
    quickScanHint: 'for a quick search with Subfinder,',
    fullScanHint: 'for an in-depth search.',
    configurableTools: 'Configurable tools: Subfinder, Amass, DNSRecon, IP Resolution',
    dataFromWorkspace: 'Data loaded from workspace',
    rerunToRefresh: '— Re-run a scan to refresh',
    enrichedResultsSaved: 'Enriched results saved to workspace',
    quickDiscoveryError: 'Error during quick discovery'
  },

  // AI Agent
  aiAgent: {
    configTitle: 'Agent Configuration',
    configSubtitle: 'Adjust thresholds and behaviors of the AI agent',
    reset: 'Reset',
    save: 'Save',
    generalSettings: 'General Settings',
    agentActive: 'Agent active',
    automaticMonitoring: 'Automatic monitoring',
    autoRecovery: 'Auto-recovery',
    automaticRecovery: 'Automatic recovery',
    dailyReport: 'Daily report',
    summaryEmail: 'Summary email',
    alertThresholds: 'Alert Thresholds',
    alert: 'Alert',
    critical: 'Critical',
    memory: 'Memory',
    disk: 'Disk',
    intervals: 'Intervals',
    monitoringSeconds: 'Monitoring (seconds)',
    aiAnalysisSeconds: 'AI Analysis (seconds)',
    healthCheckSeconds: 'Health Check (seconds)',
    scanSettings: 'Scan Settings',
    scanTimeoutMin: 'Scan Timeout (minutes)',
    maxConcurrentScans: 'Max Concurrent Scans',
    errorRateThreshold: 'Error Rate Threshold (/h)',
    alerts: 'Alerts',
    alertEmail: 'Alert Email',
    maxAlertsHour: 'Max Alerts/Hour',
    deduplication: 'Deduplication (minutes)',
    aiModels: 'AI Models',
    primaryModel: 'Primary Model',
    strategicModel: 'Strategic Model',
    technicalModel: 'Technical Model',
    codeModel: 'Code Model',
    dailyReportSettings: 'Daily Report',
    sendTime: 'Send time',
    utcNote: '0-23 (UTC time)',
    recipients: 'Recipients (one per line)',
    conversationHistory: 'AI Conversation History',
    noConversations: 'No conversations',
    selectConversation: 'Select a conversation',
    configSaved: 'Configuration saved',
    configSaveError: 'Error saving configuration',
    configReset: 'Configuration reset',
    configResetError: 'Error resetting configuration',
    configResetConfirm: 'Reset to default configuration?',
    deleteConversationConfirm: 'Delete this conversation?',
    conversationDeleted: 'Conversation deleted',
    conversationDeleteError: 'Error deleting conversation',
    loadMessagesError: 'Error loading messages',
    untitledConversation: 'Untitled conversation',
    modelsTitle: 'AI Models (Ollama)',
    modelsSubtitle: 'Status of LLM models used by the agent',
    ollamaOnline: 'Online',
    ollamaStopped: 'Stopped',
    ollamaError: 'Error',
    vramAvailable: 'Available memory for models',
    defaultModel: 'Default model',
    availableModels: 'Available Models',
    loaded: 'Loaded',
    available: 'Available',
    notAvailable: 'Not available',
    noModelsDetected: 'No models detected',
    usageStats: 'Usage Statistics ({period})',
    totalRequests: 'Total Requests',
    tokensUsed: 'Tokens Used',
    requestsByModel: 'Requests by model',
    avgLatency: 'Average latency (ms)',
    testModel: 'Test',
    modelError: 'Error: {error}',
    testError: 'Error during test',
    loadModelsError: 'Error loading models',
    actionsTitle: 'Actions History',
    actionsSubtitle: 'Actions executed by the AI agent',
    totalActions: 'Total Actions',
    successful: 'Successful',
    failed: 'Failed',
    successRate: 'Success Rate',
    actionsByType: 'Actions by type',
    noActionsRecorded: 'No actions recorded',
    filterType: 'Type',
    filterCategory: 'Category',
    filterResult: 'Result',
    all: 'All',
    allCategories: 'All',
    succeeded: 'Succeeded',
    loadActionsError: 'Error loading actions',
    metricsTitle: 'System Metrics',
    noData: 'No data',
    loadMetricsError: 'Error loading metrics',
    incidentsTitle: 'Incidents',
    incidentsSubtitle: 'Incidents detected by the AI agent',
    acknowledge: 'Acknowledge',
    resolve: 'Resolve',
    retryRecovery: 'Retry recovery',
    incidentAcknowledged: 'Incident acknowledged',
    incidentResolved: 'Incident resolved',
    recoveryRelaunched: 'Recovery relaunched',
    loadIncidentsError: 'Error loading incidents',
    noIncidents: 'No incidents',
    filterSeverity: 'Severity',
    filterStatus: 'Status',
    allSeverities: 'All',
    allStatuses: 'All'
  },

  // Orchestrator
  orchestrator: {
    title: 'AI Orchestrator',
    subtitle: 'Intelligent exploitation and autonomous analysis engine',
    active: 'ACTIVE',
    inactive: 'INACTIVE',
    disable: 'Disable',
    enable: 'Enable (Safe Mode)',
    enableSafe: 'Enable',
    retry: 'Retry',
    connectionError: 'Orchestrator connection error',
    serviceUnavailable: 'Service temporarily unavailable. Please try again.',
    stateChangeError: 'Error changing orchestrator state',
    activeScans: 'Active scans',
    aiDecisions: 'AI Decisions',
    aiModels: 'AI Models',
    minConfidence: 'Min. confidence',
    loadedModels: 'Loaded AI models',
    loadingModels: 'Loading Ollama models...',
    exploitationMode: 'Exploitation mode',
    confidenceThreshold: 'Confidence threshold',
    minConfidenceNote: 'Minimum confidence level for automatic actions',
    safeModeNote: 'Safe mode avoids destructive exploits',
    recentDecisions: 'Recent AI decisions',
    noAiActivity: 'No AI activity yet',
    decisionsAppearHere: 'AI analyses and decisions will appear here',
    configuration: 'Configuration'
  },

  // License
  license: {
    expiredBadge: 'LICENSE EXPIRED',
    revokedBadge: 'LICENSE REVOKED',
    cancelledBadge: 'LICENSE CANCELLED',
    noLicenseBadge: 'NO LICENSE',
    expiredTitle: 'Your license has expired',
    expiredSubtitle: 'Platform access is suspended pending renewal.',
    revokedTitle: 'Your license has been revoked',
    revokedSubtitle: 'Platform access has been suspended by SYLink Security. Contact your account manager.',
    cancelledTitle: 'Your license has been cancelled',
    cancelledSubtitle: 'Your subscription has been cancelled. Your data is kept for 30 days.',
    noLicenseTitle: 'No active license',
    noLicenseSubtitle: 'Activate a license to access the SYLink Pentest platform.',
    renewAction: 'Renew my license',
    accessSettings: 'Access settings',
    contactSyLink: 'Contact SYLink',
    subscribeAction: 'Subscribe to a new plan',
    exportData: 'Export my data',
    activateLicense: 'Activate my license',
    licenseInfo: 'License information',
    reference: 'Reference',
    tier: 'Tier',
    expiredOn: 'Expired on',
    holder: 'Holder',
    expiry: 'Expiry',
    plan: 'Plan',
    loggedAs: 'Logged in as',
    adminBypass: 'Administrator - Redirecting to dashboard...',
    contactSupport: 'Contact support',
    warningExpired: 'Your data is preserved. Renew your license to restore full platform access.',
    warningExpiredEmail: 'A reminder email has been sent to',
    warningRevoked: 'Access has been revoked following an administrative decision. Contact your SYLink account manager immediately.',
    warningCancelled: 'Your subscription has been cancelled. You have 30 days to export your data before permanent deletion.',
    warningNoLicense: 'Go to your account settings to enter your license key and activate the platform.',
    needHelp: 'Need help?'
  },

  // Accept Invitation
  acceptInvitation: {
    verifying: 'Verifying invitation...',
    alreadyActivatedTitle: 'Account already activated',
    alreadyActivatedDesc: 'Your account has been activated successfully. You can now log in with your email and password.',
    login: 'Log in',
    invitationExpiredTitle: 'Invitation expired',
    invitationInvalidTitle: 'Invalid invitation',
    expiredHint: 'Invitations are valid for 7 days. Ask your administrator to resend a new invitation.',
    invalidHint: 'If you received multiple invitation emails, use the link from the latest email.',
    contactSupport: 'Contact support',
    welcomeTitle: 'Welcome to the team!',
    accountActivated: 'Your account has been activated successfully.',
    redirecting: 'Redirecting to dashboard...',
    joinTeamTitle: 'Invitation to join the team',
    missingToken: 'Missing invitation token',
    acceptError: 'Error accepting invitation',
    genericError: 'An error occurred'
  },

  // Dedicated Server page
  dedicatedServer: {
    pageTitle: 'Dedicated Server - Sovereign Infrastructure',
    heroTag: '100% French Sovereign Solution',
    heroTitle: 'Dedicated',
    heroTitleHighlight: 'Infrastructure',
    heroDesc: 'An isolated, managed, and supervised pentest solution for your company. Hosted in France, without constraints of foreign solutions.',
    statFrench: 'French',
    statQueue: 'Queue',
    statSupervision: 'Supervision',
    statAvailability: 'Availability',
    whyDedicated: 'Why choose dedicated infrastructure?',
    whyDedicatedDesc: 'Benefit from a tailor-made solution adapted to your security and performance requirements',
    hostingOptions: 'Hosting options',
    hostingOptionsDesc: 'Choose the hosting that fits your needs: in our sovereign datacenter or directly in your infrastructure',
    recommended: 'Recommended',
    aiTitle: 'SYLink AI - Specialized Cybersecurity Models',
    aiDesc: 'Deploy our specialized cybersecurity AI directly on your infrastructure. Local analysis, without sending data outside.',
    parameters: 'parameters',
    poweredBy: 'Powered by Ollama',
    localLLM: 'Local LLM model execution',
    viewOnOllama: 'View on Ollama',
    ctaTitle: 'Ready to switch to dedicated infrastructure?',
    ctaDesc: 'Contact our sales team for a personalized assessment of your needs and a custom quote.',
    requestQuote: 'Request a quote',
    viewAllPlans: 'View all plans',
    trustFrenchTech: 'French Technology',
    trustFrenchTechDesc: 'Developed in France, without dependency on foreign technologies',
    trustGDPR: 'GDPR Compliance',
    trustGDPRDesc: 'Sovereign hosting compliant with European regulations',
    trustProtectedData: 'Protected Data',
    trustProtectedDataDesc: 'Your data stays in France, protected from the Cloud Act and FISA',
    adv1Title: 'Total Isolation',
    adv1Desc: 'Dedicated and isolated infrastructure for maximum security. No resource sharing with other clients.',
    adv2Title: 'Guaranteed Performance',
    adv2Desc: 'Dedicated CPU, RAM, and storage resources. Instant scans with no queues or limitations.',
    adv3Title: 'Data Sovereignty',
    adv3Desc: '100% French hosting, without constraints of foreign solutions (Cloud Act, FISA).',
    adv4Title: 'Supervision 24/7',
    adv4Desc: 'Continuous monitoring, real-time alerts, and proactive intervention by our teams.',
    adv5Title: 'Dedicated Support',
    adv5Desc: 'Dedicated technical team, guaranteed SLA, and personalized support.',
    adv6Title: '99.9% Availability',
    adv6Desc: 'Redundant infrastructure with high availability and disaster recovery plan.',
    hostingDatacenterTitle: 'France Data Center - Reims',
    hostingDatacenterLoc: 'Reims, France',
    hostingOnPremTitle: 'On-site',
    hostingOnPremLoc: 'Your infrastructure',
    ai8bDesc: 'Lightweight and fast model for standard analyses',
    ai8bSpecs: 'GPU: 8GB VRAM minimum',
    ai8bUseCase: 'Fast analyses, automated reports',
    ai30bDesc: 'Balanced model for in-depth analyses',
    ai30bSpecs: 'GPU: 24GB VRAM minimum',
    ai30bUseCase: 'Detailed analyses, advanced correlations',
    ai80bDesc: 'Expert model for complex analyses',
    ai80bSpecs: 'GPU: 80GB VRAM minimum',
    ai80bUseCase: 'Expert analyses, vulnerability research'
  },

  // Account Reports Config page
  accountReports: {
    configSaved: 'Configuration saved',
    configSaveError: 'Error saving configuration',
    clientAdded: 'Client added',
    clientAddError: 'Error adding client',
    clientDeleted: 'Client deleted',
    clientDeleteError: 'Error deleting client',
    loadError: 'Error loading data',
    deleteClientConfirm: 'Delete this client?',
    unsavedChanges: 'You have unsaved changes',
    save: 'Save',
    saving: 'Saving...',
    clientsTitle: 'Clients',
    addClient: 'Add',
    clientName: 'Client name *',
    sirenOptional: 'SIREN (optional)',
    noClientsConfigured: 'No clients configured',
    reportTypesTitle: 'Report Types',
    reportTypesDesc: 'Customize the report types available for your organization',
    customName: 'Custom name',
    customDescription: 'Custom description',
    infoNote: 'These settings are specific to your organization. Changes only affect your reports.'
  }
};
